export const levelGetContent = {
  en: {
    B: [
      {
        title: "P1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L1",
        storyMode: true,
        multilingual: true,
        customLetters: ["a", "m", "s", "t"],
        mechanism: { id: "letterTrain", name: "letterTrain" },
      },
      {
        title: "P2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L2",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        letterHuntLevel: 1,
        multilingual: true,
      },
      {
        title: "P3",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L1",
        storyMode: true,
        multilingual: true,
        customLetters: ["p", "l", "f", "n"],
        mechanism: { id: "letterTrain", name: "letterTrain" },
      },
      {
        title: "P4",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L2",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        letterHuntLevel: 2,
        multilingual: true,
      },
      {
        title: "P5",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L1",
        storyMode: true,
        multilingual: true,
        customLetters: ["o", "am", "an", "h"],
        mechanism: { id: "letterTrain", name: "letterTrain" },
      },
      {
        title: "P6",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L2",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        letterHuntLevel: 3,
        multilingual: true,
      },
      {
        title: "P7",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L3",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        letterHuntLevel: 1,
        letterHuntEndLevel: 3,
        isShowcase: true,
        multilingual: true,
      },
      {
        title: "P6",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L4",
        multilingual: true,
      },
      {
        title: "P7",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P3",
        multilingual: true,
      },
      {
        title: "P8",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P4",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        letterHuntLevel: 1,
        letterHuntEndLevel: 3,
        isShowcase: true,
        multilingual: true,
      },
      {
        title: "S2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_S2",
        multilingual: true,
      },
    ],
    F1: [
      // Learn 1 - Letter Train
      {
        title: "L1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L1",
        multilingual: true,
        mechanism: { id: "letterTrain", name: "letterTrain" },
        customLetters: ["E", "T", "A", "O"],
        contentCount: 10,
      },
      // Practice 1 - Letter Hunt (1 level, 10 content)
      {
        title: "P1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L2",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: true,
        letterHuntLevel: 1,
        contentCount: 10,
        letterHuntContentCount: 10,
      },
      // Learn 2 - Letter Train
      {
        title: "L2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P1",
        multilingual: true,
        mechanism: { id: "letterTrain", name: "letterTrain" },
        customLetters: ["I", "N", "S", "R"],
        contentCount: 10,
      },
      // Practice 2 - Letter Hunt (1 level, 10 content)
      {
        title: "P2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P2",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: true,
        letterHuntLevel: 2,
        contentCount: 10,
        letterHuntContentCount: 10,
      },
      // Learn 3 - Letter Train
      {
        title: "L3",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L3",
        multilingual: true,
        mechanism: { id: "letterTrain", name: "letterTrain" },
        customLetters: ["H", "L", "D", "C"],
        contentCount: 10,
      },
      // Practice 3 - Letter Hunt (1 level, 10 content)
      {
        title: "P3",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L4",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: true,
        letterHuntLevel: 3,
        contentCount: 10,
        letterHuntContentCount: 10,
      },
      // Apply 1 - Letter Hunt (3 levels, 13 content per level, showcase mode)
      {
        title: "A1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P3",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: true,
        letterHuntLevel: 1,
        letterHuntEndLevel: 3,
        letterHuntContentCount: 13,
        isShowcase: true,
        applyStep: 1,
        contentCount: 30,
        failRedirect: "L1", // If fail at any level, go to Learn 1
        passRedirect: "L4", // If pass all levels, go to Learn 4
      },
      // Learn 4 - Letter Train
      {
        title: "L4",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P4",
        multilingual: true,
        mechanism: { id: "letterTrain", name: "letterTrain" },
        customLetters: ["U", "M", "F", "P"],
        contentCount: 10,
      },
      // Practice 4 - Letter Hunt (1 level, 10 content)
      {
        title: "P4",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P5",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: true,
        letterHuntLevel: 4,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Learn 5 - Letter Train
      {
        title: "L5",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L5",
        multilingual: true,
        mechanism: { id: "letterTrain", name: "letterTrain" },
        customLetters: ["G", "W", "Y", "B"],
        contentCount: 10,
      },
      // Practice 5 - Letter Hunt (1 level, 10 content)
      {
        title: "P5",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L6",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: true,
        letterHuntLevel: 5,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Learn 6 - Letter Train
      {
        title: "L6",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P6",
        multilingual: true,
        mechanism: { id: "letterTrain", name: "letterTrain" },
        customLetters: ["V", "K", "X", "J"],
        contentCount: 10,
      },
      // Practice 6 - Letter Hunt (1 level, 10 content)
      {
        title: "P6",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P7",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: true,
        letterHuntLevel: 6,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Apply 2 - Letter Hunt (3 levels, 13 content per level, showcase mode)
      {
        title: "A2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P8",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: true,
        letterHuntLevel: 4,
        letterHuntEndLevel: 6,
        letterHuntContentCount: 13,
        isShowcase: true,
        applyStep: 2,
        contentCount: 30,
        failRedirect: "L4", // If fail at any level, go to Learn 4
        passRedirect: "L7", // If pass all levels, go to Learn 7
      },
      // Learn 7 - Letter Train
      {
        title: "L7",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P9",
        multilingual: true,
        mechanism: { id: "letterTrain", name: "letterTrain" },
        customLetters: ["Q", "Z", "E", "T"],
        contentCount: 10,
      },
      // Practice 7 - Letter Hunt (1 level, 10 content)
      {
        title: "P7",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P10",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: true,
        letterHuntLevel: 7,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Learn 8 - Letter Train
      {
        title: "L8",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P11",
        multilingual: true,
        mechanism: { id: "letterTrain", name: "letterTrain" },
        customLetters: ["A", "O", "I", "N"],
        contentCount: 10,
      },
      // Practice 8 - Letter Hunt (1 level, 10 content)
      {
        title: "P8",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P12",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: true,
        letterHuntLevel: 8,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Learn 9 - Letter Train
      {
        title: "L9",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P13",
        multilingual: true,
        mechanism: { id: "letterTrain", name: "letterTrain" },
        customLetters: ["S", "R", "H", "L"],
        contentCount: 10,
      },
      // Practice 9 - Letter Hunt (1 level, 10 content)
      {
        title: "P9",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P14",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: true,
        letterHuntLevel: 9,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Apply 3 - Letter Hunt (3 levels, 13 content per level, showcase mode)
      {
        title: "A3",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P15",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: true,
        letterHuntLevel: 7,
        letterHuntEndLevel: 9,
        letterHuntContentCount: 13,
        isShowcase: true,
        applyStep: 3,
        contentCount: 30,
        failRedirect: "L7", // If fail at any level, go to Learn 7
        passRedirect: "F2", // If pass all levels, go to F2
      },
    ],
    F2: [
      // Learn 1 - Syllable Clap/Letter Train (English) or Barakadi (Indic)
      {
        title: "L1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L1",
        multilingual: true,
        mechanism: { id: "letterTrain", name: "letterTrain" }, // For English, use LetterTrain; for Indic, will use Barakhadi
        customLetters: ["me", "be", "he", "the", "her", "ear"], // Placeholder - adjust based on F2 requirements
        contentCount: 10,
      },
      // Practice 1 - Letter Hunt (1 level, 10 content)
      {
        title: "P1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L2",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: true,
        letterHuntLevel: 1,
        letterHuntContentCount: 10,
        contentCount: 10,
        customLetters: ["me", "be", "he", "the", "her", "ear"],
      },
      // Learn 2 - Syllable Clap/Letter Hunt (English) or Barakadi (Indic)
      {
        title: "L2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P1",
        multilingual: true,
        mechanism: { id: "letterTrain", name: "letterTrain" }, // For English, use LetterTrain; for Indic, will use Barakhadi
        customLetters: ["Go", "Do", "So", "No", "to", "not"], // Placeholder - adjust based on F2 requirements
        contentCount: 10,
      },
      // Practice 2 - Letter Hunt (1 level, 10 content)
      {
        title: "P2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P2",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        customLetters: ["Go", "Do", "So", "No", "to", "not"],
        multilingual: true,
        letterHuntLevel: 2,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Learn 3 - Syllable Clap/Letter Hunt (English) or Barakadi (Indic)
      {
        title: "L3",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L3",
        multilingual: true,
        mechanism: { id: "letterTrain", name: "letterTrain" }, // For English, use LetterTrain; for Indic, will use Barakhadi
        customLetters: ["or", "of", "our", "on", "one", "Ox"], // Placeholder - adjust based on F2 requirements
        contentCount: 10,
      },
      // Practice 3 - Letter Hunt (1 level, 10 content)
      {
        title: "P3",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L4",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        customLetters: ["or", "of", "our", "on", "one", "Ox"],
        multilingual: true,
        letterHuntLevel: 3,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Apply 1 - Letter Hunt (3 levels, 13 content per level, showcase mode)
      {
        title: "A1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P3",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: true,
        letterHuntLevel: 10,
        letterHuntEndLevel: 12,
        letterHuntContentCount: 13,
        isShowcase: true,
        applyStep: 1,
        contentCount: 30,
        failRedirect: "L1", // If fail at any level, go to Learn 1
        passRedirect: "L4", // If pass all levels, go to Learn 4
      },
      // Learn 4 - Syllable Clap/Letter Hunt (English) or Barakadi (Indic)
      {
        title: "L4",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P4",
        multilingual: true,
        mechanism: { id: "letterTrain", name: "letterTrain" }, // For English, use LetterTrain; for Indic, will use Barakhadi
        customLetters: ["as", "was", "Up", "Us", "all", "for"], // Placeholder - adjust based on F2 requirements
        contentCount: 10,
      },
      // Practice 4 - Letter Hunt (1 level, 10 content)
      {
        title: "P4",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P5",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        customLetters: ["as", "was", "Up", "Us", "all", "for"],
        multilingual: true,
        letterHuntLevel: 1,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Learn 5 - Syllable Clap/Letter Hunt (English) or Barakadi (Indic)
      {
        title: "L5",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P6",
        multilingual: true,
        mechanism: { id: "letterTrain", name: "letterTrain" }, // For English, use LetterTrain; for Indic, will use Barakhadi
        customLetters: ["My", "hi", "his", "is", "in", "Ink"], // Placeholder - adjust based on F2 requirements
        contentCount: 10,
      },
      // Practice 5 - Letter Hunt (1 level, 10 content)
      {
        title: "P5",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P7",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: true,
        letterHuntLevel: 1,
        customLetters: ["My", "hi", "his", "is", "in", "Ink"],
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Learn 6 - Syllable Clap/Letter Hunt (English) or Barakadi (Indic)
      {
        title: "L6",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P8",
        multilingual: true,
        mechanism: { id: "letterTrain", name: "letterTrain" }, // For English, use LetterTrain; for Indic, will use Barakhadi
        customLetters: ["at", "hat", "rat", "an", "Am", "and"], // Placeholder - adjust based on F2 requirements
        contentCount: 10,
      },
      // Practice 6 - Letter Hunt (1 level, 10 content)
      {
        title: "P6",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P9",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: true,
        customLetters: ["at", "hat", "rat", "an", "Am", "and"],
        letterHuntLevel: 1,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Apply 2 - Letter Hunt (3 levels, 13 content per level, showcase mode)
      {
        title: "A2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P10",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: true,
        letterHuntLevel: 13,
        letterHuntEndLevel: 15,
        letterHuntContentCount: 13,
        isShowcase: true,
        applyStep: 2,
        contentCount: 30,
        failRedirect: "L4", // If fail at any level, go to Learn 4
        passRedirect: "L7", // If pass all levels, go to Learn 7
      },
      // Learn 7 - Syllable Clap/Letter Hunt (English) or Barakadi (Indic)
      {
        title: "L7",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P11",
        multilingual: true,
        mechanism: { id: "letterTrain", name: "letterTrain" }, // For English, use LetterTrain; for Indic, will use Barakhadi
        customLetters: ["it", "wit", "Bit", "Fit", "Fun", "men"], // Placeholder - adjust based on F2 requirements
        contentCount: 10,
      },
      // Practice 7 - Letter Hunt (1 level, 10 content)
      {
        title: "P7",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P12",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: true,
        customLetters: ["it", "wit", "Bit", "Fit", "Fun", "men"],
        letterHuntLevel: 1,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Learn 8 - Syllable Clap/Letter Hunt (English) or Barakadi (Indic)
      {
        title: "L8",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P13",
        multilingual: true,
        mechanism: { id: "letterTrain", name: "letterTrain" }, // For English, use LetterTrain; for Indic, will use Barakhadi
        customLetters: ["ate", "Age", "Ask", "Act", "Arm", "Art"], // Placeholder - adjust based on F2 requirements
        contentCount: 10,
      },
      // Practice 8 - Letter Hunt (1 level, 10 content)
      {
        title: "P8",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P14",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: true,
        customLetters: ["ate", "Age", "Ask", "Act", "Arm", "Art"],
        letterHuntLevel: 1,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Learn 9 - Syllable Clap/Letter Hunt (English) or Barakadi (Indic)
      {
        title: "L9",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P15",
        multilingual: true,
        mechanism: { id: "letterTrain", name: "letterTrain" }, // For English, use LetterTrain; for Indic, will use Barakhadi
        customLetters: ["Bed", "Fly", "Ice", "Key", "Car", "Air"], // Placeholder - adjust based on F2 requirements
        contentCount: 10,
      },
      // Practice 9 - Letter Hunt (1 level, 10 content)
      {
        title: "P9",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P16",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: true,
        letterHuntLevel: 1,
        letterHuntContentCount: 10,
        contentCount: 10,
        customLetters: ["Bed", "Fly", "Ice", "Key", "Car", "Air"],
      },
      // Apply 3 - Letter Hunt (3 levels, 13 content per level, showcase mode)
      {
        title: "A3",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P17",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: true,
        letterHuntLevel: 16,
        letterHuntEndLevel: 18,
        letterHuntContentCount: 13,
        isShowcase: true,
        applyStep: 3,
        contentCount: 30,
        failRedirect: "L7", // If fail at any level, go to Learn 7
        passRedirect: "F3", // If pass all levels, go to F3
      },
    ],
    F3: [
      // Practice 1 - Letter Speed (Letter Launcher) - Alphabet sets
      {
        title: "P1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_P1",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: true,
        contentType: "letter", // Alphabet sets
        letterLauncherLevel: 19,
        letterLauncherContentCount: 10,
        contentCount: 10,
      },
      // Practice 2 - Letter Speed (Letter Launcher) - Alphabet sets
      {
        title: "P2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_P2",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: true,
        contentType: "letter",
        letterLauncherLevel: 20,
        letterLauncherContentCount: 10,
        contentCount: 10,
      },
      // Practice 3 - Letter Speed (Letter Launcher) - Alphabet sets
      {
        title: "P3",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_P3",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: true,
        contentType: "letter",
        letterLauncherLevel: 21,
        letterLauncherContentCount: 10,
        contentCount: 10,
      },
      // Practice 4 - Letter Speed (Letter Launcher) - Alphabet sets
      {
        title: "P4",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_P4",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: true,
        contentType: "letter",
        letterLauncherLevel: 20,
        letterLauncherContentCount: 10,
        contentCount: 10,
      },
      // Practice 5 - Letter Speed (Letter Launcher) - Alphabet sets
      {
        title: "P5",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_P5",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: true,
        contentType: "letter",
        letterLauncherLevel: 21,
        letterLauncherContentCount: 10,
        contentCount: 10,
      },
      // Apply 1 - Letter Speed (Letter Launcher) 3 levels + Memory Challenge 3 levels
      {
        title: "A1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_A1",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: true,
        contentType: "letter",
        letterLauncherLevel: 19,
        letterLauncherEndLevel: 21,
        letterLauncherContentCount: 20,
        isShowcase: true,
        applyStep: 1,
        contentCount: 35, // 20 letterLauncher + 15 memoryChallenge (3 levels × 5 sequences)
        failRedirect: "P1", // If fail at any level, go to Practice 1
        passRedirect: "P6", // If pass all levels, go to Practice 6
        // After Letter Launcher completes, show Memory Challenge
        memoryChallengeLevel: 19,
        memoryChallengeEndLevel: 21,
        memoryChallengeContentCount: 5, // 5 sequences per level
      },
      // Practice 6 - Syllable Speed (Letter Launcher) - Syllable sets
      {
        title: "P6",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_P6",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: true,
        contentType: "syllable", // Syllable sets
        letterLauncherLevel: 22,
        letterLauncherContentCount: 10,
        contentCount: 10,
      },
      // Practice 7 - Syllable Speed (Letter Launcher) - Syllable sets
      {
        title: "P7",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_P7",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: true,
        contentType: "syllable",
        letterLauncherLevel: 23,
        letterLauncherContentCount: 10,
        contentCount: 10,
      },
      // Practice 8 - Syllable Speed (Letter Launcher) - Syllable sets
      {
        title: "P8",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_P8",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: true,
        contentType: "syllable",
        letterLauncherLevel: 24,
        letterLauncherContentCount: 10,
        contentCount: 10,
      },
      // Practice 9 - Syllable Speed (Letter Launcher) - Syllable sets
      {
        title: "P9",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_P9",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: true,
        contentType: "syllable",
        letterLauncherLevel: 23,
        letterLauncherContentCount: 10,
        contentCount: 10,
      },
      // Practice 10 - Syllable Speed (Letter Launcher) - Syllable sets
      {
        title: "P10",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_P10",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: true,
        contentType: "syllable",
        letterLauncherLevel: 24,
        letterLauncherContentCount: 10,
        contentCount: 10,
      },
      // Apply 2 - Syllable Speed (Letter Launcher) 1 level + Memory Challenge 3 levels + Read Aloud
      {
        title: "A2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_A2",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: true,
        contentType: "syllable",
        letterLauncherLevel: 22,
        letterLauncherEndLevel: 24,
        letterLauncherContentCount: 20,
        isShowcase: true,
        applyStep: 2,
        contentCount: 45, // 20 letterLauncher + 15 memoryChallenge (3 levels × 5 sequences) + 10 readAloud
        failRedirect: "P6", // If fail at any level, go to Practice 6
        passRedirect: "complete", // If pass all levels, complete F3
        // After Letter Launcher completes, show Memory Challenge
        memoryChallengeLevel: 22,
        memoryChallengeEndLevel: 24,
        memoryChallengeContentCount: 5, // 5 sequences per level
        // After Memory Challenge completes, show Read Aloud
        readAloudContentCount: 10, // 10 simple root words
      },
    ],
    0: [
      {
        title: "P1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_ENG",
        storyMode: true,
      },
      { title: "P2", criteria: "word", template: "simple", tags: "CEFR_ENG" },
      { title: "P3", criteria: "word", template: "simple", tags: "CEFR_ENG" },
      { title: "P4", criteria: "word", template: "simple", tags: "CEFR_ENG" },
      { title: "S1", criteria: "word", template: "simple", tags: "CEFR_ENG" },
      { title: "P5", criteria: "word", template: "simple", tags: "CEFR_ENG" },
      { title: "P6", criteria: "word", template: "simple", tags: "CEFR_ENG" },
      { title: "P7", criteria: "word", template: "simple", tags: "CEFR_ENG" },
      { title: "P8", criteria: "word", template: "simple", tags: "CEFR_ENG" },
      { title: "S2", criteria: "word", template: "simple", tags: "CEFR_ENG" },
    ],
    1: [
      {
        title: "P1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L1",
        contentCount: 10,
        //storyMode: true,
        mechanism: { id: "mechanic_7", name: "formAWord2" },
        multilingual: true,
      },
      {
        title: "P2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L2",
        contentCount: 10,
        mechanism: { id: "mechanic_7", name: "formAWord2" },
        multilingual: true,
      },
      {
        title: "P3",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P1",
        mechanism: { id: "soundHunt", name: "soundHunt" },
        contentCount: 10,
        multilingual: true,
      },
      {
        title: "P4",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P2",
        contentCount: 10,
        multilingual: true,
      },
      {
        title: "S1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_S1",
        contentCount: 10,
        mechanism: { id: "soundHuntS1Combined", name: "soundHuntS1Combined" },
        multilingual: true,
      },
      {
        title: "P5",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L3",
        mechanism: { id: "mechanic_7", name: "formAWord2" },
        contentCount: 10,
        multilingual: true,
      },
      {
        title: "P6",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L4",
        mechanism: { id: "mechanic_7", name: "formAWord2" },
        contentCount: 10,
        multilingual: true,
      },
      {
        title: "P7",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P3",
        mechanism: { id: "soundHunt", name: "soundHunt" },
        contentCount: 10,
        multilingual: true,
      },
      {
        title: "P8",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P4",
        contentCount: 10,
        multilingual: true,
      },
      {
        title: "S2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_S2",
        mechanism: { id: "soundHuntS1Combined", name: "soundHuntS1Combined" },
        contentCount: 10,
        multilingual: true,
      },
    ],
    2: [
      {
        title: "P1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M2_L1",
        mechanism: { id: "bingo_card", name: "bingoCard" },
        multilingual: true,
      },
      {
        title: "P2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M2_L2",
        mechanism: { id: "bingo_card", name: "bingoCard" },
        multilingual: true,
      },
      {
        title: "P3",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M2_P1",
        mechanism: { id: "soundHunt", name: "soundHunt" },
        contentCount: 10,
        //storyMode: true,
        multilingual: true,
      },
      {
        title: "P4",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M2_P2",
        multilingual: true,
        contentCount: 10,
      },
      {
        title: "S1",
        criteria: "word",
        template: "simple",
        mechanism: { id: "soundHuntS1Combined", name: "soundHuntS1Combined" },
        multilingual: true,
      },
      {
        title: "P5",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M2_L3",
        mechanism: { id: "bingo_card", name: "bingoCard" },
        multilingual: true,
      },
      {
        title: "P6",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M2_L4",
        mechanism: { id: "bingo_card", name: "bingoCard" },
        multilingual: true,
      },
      {
        title: "P7",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M2_P3",
        mechanism: { id: "soundHunt", name: "soundHunt" },
        contentCount: 10,
        multilingual: true,
      },
      {
        title: "P8",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M2_P4",
        multilingual: true,
        contentCount: 10,
      },
      {
        title: "S2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M2_S2",
        mechanism: { id: "soundHuntS1Combined", name: "soundHuntS1Combined" },
        multilingual: true,
      },
    ],
    3: [
      {
        // Index 0: practiceSteps[0].name="P1", titleThree="L1" → L1 (Phrase Reading) - step1 mode, 10 words
        // title must match practiceSteps[0].name ("P1") for content lookup
        title: "P1",
        criteria: "sentence",
        template: "simple",
        tags: "CEFR_GEN_M3_L1",
        mechanism: { id: "PhrasesInAction", name: "PhrasesInAction" },
        contentCount: 10,
        multilingual: true,
      },
      {
        // Index 1: practiceSteps[1].name="P2", titleThree="P1" → P1 (Repeat Phrase) - step1 mode, 10 words
        // title must match practiceSteps[1].name ("P2") for content lookup
        title: "P2",
        criteria: "sentence",
        template: "simple",
        tags: "CEFR_GEN_M3_L2",
        mechanism: { id: "PhrasesInAction", name: "PhrasesInAction" },
        contentCount: 10,
        multilingual: true,
      },
      {
        // Index 2: practiceSteps[2].name="P3", titleThree="P2" → P2 (Correct Image Phrase) - step2 mode, 10 words
        // title must match practiceSteps[2].name ("P3") for content lookup
        title: "P3",
        criteria: "sentence",
        template: "simple",
        tags: "CEFR_GEN_M3_P1",
        // mechanism: { id: "PhrasesInAction", name: "PhrasesInAction" },
        contentCount: 10,
        multilingual: true,
      },
      {
        // Index 3: practiceSteps[3].name="P4", titleThree="L2" → L2 (Phrase Reading) - step1 mode, 10 words
        // title must match practiceSteps[3].name ("P4") for content lookup
        title: "P4",
        criteria: "sentence",
        template: "simple",
        tags: "CEFR_GEN_M3_P2",
        // mechanism: { id: "PhrasesInAction", name: "PhrasesInAction" },
        contentCount: 10,
        multilingual: true,
      },
      {
        // Index 4: practiceSteps[4].name="S1", titleThree="S1" → S1 (Phrase Reading with ASR) - ASR task, 10 words from above 40
        // title must match practiceSteps[4].name ("S1") for content lookup
        title: "S1",
        criteria: "sentence",
        template: "simple",
        tags: "CEFR_GEN_M3_S1",
        contentCount: 10, // 10 words from the above 40
        multilingual: true,
      },
      {
        // Index 5: practiceSteps[5].name="P5", titleThree="L3" → L3 (Repeat Phrase) - step1 mode, 10 words
        // title must match practiceSteps[5].name ("P5") for content lookup
        title: "P5",
        criteria: "sentence",
        template: "simple",
        tags: "CEFR_GEN_M3_L3",
        mechanism: { id: "PhrasesInAction", name: "PhrasesInAction" },
        contentCount: 10,
        multilingual: true,
      },
      {
        // Index 6: practiceSteps[6].name="P6", titleThree="P3" → P3 (Phrase Reading) - step1 mode, 10 words
        // title must match practiceSteps[6].name ("P6") for content lookup
        title: "P6",
        criteria: "sentence",
        template: "simple",
        tags: "CEFR_GEN_M3_L4",
        mechanism: { id: "PhrasesInAction", name: "PhrasesInAction" },
        contentCount: 10,
        multilingual: true,
      },
      {
        // Index 7: practiceSteps[7].name="P7", titleThree="L4" → L4 (Correct Image Phrase) - step2 mode, 10 words
        // title must match practiceSteps[7].name ("P7") for content lookup
        title: "P7",
        criteria: "sentence",
        template: "simple",
        tags: "CEFR_GEN_M3_P3",
        // mechanism: { id: "PhrasesInAction", name: "PhrasesInAction" },
        contentCount: 10,
        multilingual: true,
      },
      {
        // Index 8: practiceSteps[8].name="P8", titleThree="P4" → P4 (Phrase Reading) - step1 mode, 10 words
        // title must match practiceSteps[8].name ("P8") for content lookup
        title: "P8",
        criteria: "sentence",
        template: "simple",
        tags: "CEFR_GEN_M3_P4",
        // mechanism: { id: "PhrasesInAction", name: "PhrasesInAction" },
        contentCount: 10,
        multilingual: true,
      },
      {
        // Index 9: practiceSteps[9].name="S2", titleThree="S2" → S2 (Phrase Reading with ASR) - ASR task, 10 words from above 80
        // title must match practiceSteps[9].name ("S2") for content lookup
        title: "S2",
        criteria: "sentence",
        template: "simple",
        tags: "CEFR_GEN_M3_S2",
        contentCount: 10, // 10 words from the above 80
        multilingual: true,
      },
    ],
    4: [
      {
        title: "P1",
        criteria: "sentence",
        template: "simple",
        tags: "M4_GEN-EN_READ",
        mechanism: { id: "Fluency_P1", name: "fluencyP1" },
        multilingual: true,
      },
      {
        title: "P2",
        criteria: "sentence",
        template: "simple",
        tags: "M4_GEN-EN_READ",
        mechanism: { id: "Fluency_P2", name: "fluencyP2" },
        multilingual: true,
      },
      {
        title: "P3",
        criteria: "sentence",
        template: "simple",
        tags: "M4_GEN-EN_READ",
        mechanism: { id: "Fluency_P3", name: "fluencyP3" },
        multilingual: true,
      },
      {
        title: "P4",
        criteria: "sentence",
        template: "simple",
        tags: "M4_GEN-EN_READ",
        mechanism: { id: "Fluency_P4", name: "fluencyP4" },
        multilingual: true,
      },
      {
        title: "S1",
        criteria: "sentence",
        template: "simple",
        competency: "L1.1",
        tags: "M4_GEN-EN_MECH",
        CEFR_level: "A1",
        mechanism: { id: "mechanic_2", name: "readTheImage" },
      },
      {
        title: "P5",
        criteria: "sentence",
        template: "simple",
        tags: "M4_GEN-EN_READ",
        mechanism: { id: "Fluency_P1", name: "fluencyP1" },
        multilingual: true,
      },
      {
        title: "P6",
        criteria: "sentence",
        template: "simple",
        tags: "M4_GEN-EN_READ",
        mechanism: { id: "Fluency_P2", name: "fluencyP2" },
        multilingual: true,
      },
      {
        title: "P7",
        criteria: "sentence",
        template: "simple",
        tags: "M4_GEN-EN_READ",
        mechanism: { id: "Fluency_P3", name: "fluencyP3" },
        multilingual: true,
      },
      {
        title: "P8",
        criteria: "sentence",
        template: "simple",
        tags: "M4_GEN-EN_READ",
        mechanism: { id: "Fluency_P4", name: "fluencyP4" },
        multilingual: true,
      },
      {
        title: "S2",
        criteria: "sentence",
        template: "simple",
        competency: "L1.2",
        tags: "M4_GEN-EN_MECH",
        CEFR_level: "A1",
        mechanism: { id: "mechanic_2", name: "readTheImage" },
      },
    ],
    5: [
      {
        title: "P1",
        criteria: "sentence",
        template: "simple",
        tags: "M5_GEN-EN_READ",
        mechanism: { id: "Fluency_P1", name: "fluencyP1" },
        multilingual: true,
      },
      {
        title: "P2",
        criteria: "sentence",
        template: "simple",
        tags: "M5_GEN-EN_READ",
        mechanism: { id: "Fluency_P2", name: "fluencyP2" },
        multilingual: true,
      },
      {
        title: "P3",
        criteria: "sentence",
        template: "simple",
        tags: "M5_GEN-EN_READ",
        mechanism: { id: "Fluency_P3", name: "fluencyP3" },
        multilingual: true,
      },
      {
        title: "P4",
        criteria: "sentence",
        template: "simple",
        tags: "M5_GEN-EN_READ",
        mechanism: { id: "Fluency_P4", name: "fluencyP4" },
        multilingual: true,
      },
      {
        title: "S1",
        criteria: "sentence",
        template: "simple",
        competency: "L1.7",
        tags: "M5_GEN-EN_MECH",
        CEFR_level: "A1",
        mechanism: { id: "mechanic_2", name: "readTheImage" },
      },
      {
        title: "P5",
        criteria: "sentence",
        template: "simple",
        tags: "M5_GEN-EN_READ",
        mechanism: { id: "Fluency_P1", name: "fluencyP1" },
        multilingual: true,
      },
      {
        title: "P6",
        criteria: "sentence",
        template: "simple",
        tags: "M5_GEN-EN_READ",
        mechanism: { id: "Fluency_P2", name: "fluencyP2" },
        multilingual: true,
      },
      {
        title: "P7",
        criteria: "sentence",
        template: "simple",
        tags: "M5_GEN-EN_READ",
        mechanism: { id: "Fluency_P3", name: "fluencyP3" },
        multilingual: true,
      },
      {
        title: "P8",
        criteria: "sentence",
        template: "simple",
        tags: "M5_GEN-EN_READ",
        mechanism: { id: "Fluency_P4", name: "fluencyP4" },
        multilingual: true,
      },
      {
        title: "S2",
        criteria: "sentence",
        template: "simple",
        competency: "L1.6",
        tags: "M5_GEN-EN_MECH",
        CEFR_level: "A1",
        mechanism: { id: "mechanic_2", name: "readTheImage" },
      },
    ],
    6: [
      {
        title: "P1",
        criteria: "sentence",
        template: "simple",
        tags: "M6_GEN-EN_READ",
        mechanism: { id: "Fluency_P1", name: "fluencyP1" },
        multilingual: true,
      },
      {
        title: "P2",
        criteria: "sentence",
        template: "simple",
        tags: "M6_GEN-EN_READ",
        mechanism: { id: "Fluency_P2", name: "fluencyP2" },
        multilingual: true,
      },
      {
        title: "P3",
        criteria: "sentence",
        template: "simple",
        tags: "M6_GEN-EN_READ",
        mechanism: { id: "Fluency_P3", name: "fluencyP3" },
        multilingual: true,
      },
      {
        title: "P4",
        criteria: "sentence",
        template: "simple",
        tags: "M6_GEN-EN_READ",
        mechanism: { id: "Fluency_P4", name: "fluencyP4" },
        multilingual: true,
      },
      {
        title: "S1",
        criteria: "sentence",
        template: "simple",
        tags: "M6_GEN-EN_READ",
      },
      {
        title: "P5",
        criteria: "sentence",
        template: "simple",
        tags: "M6_GEN-EN_READ",
        mechanism: { id: "Fluency_P1", name: "fluencyP1" },
        multilingual: true,
      },
      {
        title: "P6",
        criteria: "sentence",
        template: "simple",
        tags: "M6_GEN-EN_READ",
        mechanism: { id: "Fluency_P2", name: "fluencyP2" },
        multilingual: true,
      },
      {
        title: "P7",
        criteria: "sentence",
        template: "simple",
        tags: "M6_GEN-EN_READ",
        mechanism: { id: "Fluency_P3", name: "fluencyP3" },
        multilingual: true,
      },
      {
        title: "P8",
        criteria: "sentence",
        template: "simple",
        tags: "M6_GEN-EN_READ",
        mechanism: { id: "Fluency_P4", name: "fluencyP4" },
        multilingual: true,
      },
      {
        title: "S2",
        criteria: "sentence",
        template: "simple",
        tags: "M6_GEN-EN_READ",
      },
    ],
    7: [
      {
        title: "P1",
        criteria: "paragraph",
        template: "simple",
        tags: "CEFR_GENERAL_ENG",
        mechanism: { id: "Fluency_P5", name: "fluencyP5" },
        multilingual: true,
      },
      {
        title: "P2",
        criteria: "paragraph",
        template: "simple",
        tags: "CEFR_GENERAL_ENG",
        mechanism: { id: "Fluency_P5", name: "fluencyP5" },
        multilingual: true,
      },
      {
        title: "P3",
        criteria: "paragraph",
        template: "simple",
        tags: "CEFR_GENERAL_ENG",
        mechanism: { id: "Fluency_P3", name: "fluencyP3" },
        multilingual: true,
      },
      {
        title: "P4",
        criteria: "paragraph",
        template: "simple",
        tags: "CEFR_GENERAL_ENG",
        mechanism: { id: "Fluency_P4", name: "fluencyP4" },
        multilingual: true,
      },
      {
        title: "S1",
        criteria: "paragraph",
        template: "simple",
        tags: "CEFR_GENERAL_ENG",
      },
      {
        title: "P5",
        criteria: "paragraph",
        template: "simple",
        tags: "CEFR_GENERAL_ENG",
        mechanism: { id: "Fluency_P5", name: "fluencyP5" },
        multilingual: true,
      },
      {
        title: "P6",
        criteria: "paragraph",
        template: "simple",
        tags: "CEFR_GENERAL_ENG",
        mechanism: { id: "Fluency_P5", name: "fluencyP5" },
        multilingual: true,
      },
      {
        title: "P7",
        criteria: "paragraph",
        template: "simple",
        tags: "CEFR_GENERAL_ENG",
        mechanism: { id: "Fluency_P3", name: "fluencyP3" },
        multilingual: true,
      },
      {
        title: "P8",
        criteria: "paragraph",
        template: "simple",
        tags: "CEFR_GENERAL_ENG",
        mechanism: { id: "Fluency_P4", name: "fluencyP4" },
        multilingual: true,
      },
      {
        title: "S2",
        criteria: "paragraph",
        template: "simple",
        tags: "CEFR_GENERAL_ENG",
        //competency: "L1.8",
      },
    ],
    8: [
      {
        title: "P1",
        criteria: "paragraph",
        template: "simple",
        tags: "CEFR_GENERAL_ENG",
        mechanism: { id: "Fluency_P5", name: "fluencyP5" },
        multilingual: true,
      },
      {
        title: "P2",
        criteria: "paragraph",
        template: "simple",
        tags: "CEFR_GENERAL_ENG",
        mechanism: { id: "Fluency_P5", name: "fluencyP5" },
        multilingual: true,
      },
      {
        title: "P3",
        criteria: "paragraph",
        template: "simple",
        tags: "CEFR_GENERAL_ENG",
        mechanism: { id: "Fluency_P3", name: "fluencyP3" },
        multilingual: true,
      },
      {
        title: "P4",
        criteria: "paragraph",
        template: "simple",
        tags: "CEFR_GENERAL_ENG",
        mechanism: { id: "Fluency_P4", name: "fluencyP4" },
        multilingual: true,
      },
      {
        title: "S1",
        criteria: "paragraph",
        template: "simple",
        competency: "L1.8",
        tags: "CEFR_GENERAL_ENG",
        CEFR_level: "A2",
        //  mechanism: { id: "mechanic_2", name: "readTheImage" },
      },
      {
        title: "P5",
        criteria: "paragraph",
        template: "simple",
        tags: "CEFR_GENERAL_ENG",
        mechanism: { id: "Fluency_P5", name: "fluencyP5" },
        multilingual: true,
      },
      {
        title: "P6",
        criteria: "paragraph",
        template: "simple",
        tags: "CEFR_GENERAL_ENG",
        mechanism: { id: "Fluency_P5", name: "fluencyP5" },
        multilingual: true,
      },
      {
        title: "P7",
        criteria: "paragraph",
        template: "simple",
        tags: "CEFR_GENERAL_ENG",
        mechanism: { id: "Fluency_P3", name: "fluencyP3" },
        multilingual: true,
      },
      {
        title: "P8",
        criteria: "paragraph",
        template: "simple",
        tags: "CEFR_GENERAL_ENG",
        mechanism: { id: "Fluency_P4", name: "fluencyP4" },
        multilingual: true,
      },
      {
        title: "S2",
        criteria: "paragraph",
        template: "simple",
        competency: "L1.8",
        // mechanism: { id: "mechanic_2", name: "readTheImage" },
        tags: "CEFR_GENERAL_ENG",
        CEFR_level: "A2",
      },
    ],
    9: [
      {
        title: "P1",
        criteria: "paragraph",
        template: "simple",
        tags: "CEFR_GEN_ENG_TB",
        mechanism: { id: "Fluency_P6", name: "fluencyP6" },
        multilingual: true,
      },
      {
        title: "P2",
        criteria: "paragraph",
        template: "simple",
        tags: "CEFR_GEN_ENG_TB",
        mechanism: { id: "Fluency_P6", name: "fluencyP6" },
        multilingual: true,
      },
      {
        title: "P3",
        criteria: "paragraph",
        template: "simple",
        tags: "CEFR_GENERAL_ENG",
        mechanism: { id: "Fluency_P3", name: "fluencyP3" },
        multilingual: true,
      },
      {
        title: "P4",
        criteria: "paragraph",
        template: "simple",
        tags: "CEFR_GENERAL_ENG",
        mechanism: { id: "Fluency_P4", name: "fluencyP4" },
        multilingual: true,
      },
      {
        title: "S1",
        criteria: "paragraph",
        template: "simple",
        tags: "CEFR_GENERAL_ENG",
      },
      {
        title: "P5",
        criteria: "paragraph",
        template: "simple",
        tags: "CEFR_GEN_ENG_TB",
        mechanism: { id: "Fluency_P6", name: "fluencyP6" },
        multilingual: true,
      },
      {
        title: "P6",
        criteria: "paragraph",
        template: "simple",
        tags: "CEFR_GEN_ENG_TB",
        mechanism: { id: "Fluency_P6", name: "fluencyP6" },
        multilingual: true,
      },
      {
        title: "P7",
        criteria: "paragraph",
        template: "simple",
        tags: "CEFR_GENERAL_ENG",
        mechanism: { id: "Fluency_P3", name: "fluencyP3" },
        multilingual: true,
      },
      {
        title: "P8",
        criteria: "paragraph",
        template: "simple",
        tags: "CEFR_GENERAL_ENG",
        mechanism: { id: "Fluency_P4", name: "fluencyP4" },
        multilingual: true,
      },
      {
        title: "S2",
        criteria: "paragraph",
        template: "simple",
        tags: "CEFR_GENERAL_ENG",
      },
    ],
    10: [
      {
        title: "P1",
        criteria: "sentence",
        template: "simple",
        mechanism: { id: "AnouncementFlow", name: "AnouncementFlow" },
        //tags: "CEFR_ENG",
        //competency: "L2.1",
      },
      {
        title: "P2",
        criteria: "sentence",
        template: "simple",
        mechanism: { id: "McqFlow", name: "McqFlow" },
      },
      {
        title: "P3",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "r3", name: "r3" },
      },
      {
        title: "P4",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "AnouncementFlow", name: "AnouncementFlow" },
      },
      {
        title: "S1",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "AnouncementFlow", name: "AnouncementFlow" },
      },
      {
        title: "P5",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "AnouncementFlow", name: "AnouncementFlow" },
      },
      {
        title: "P6",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "McqFlow", name: "McqFlow" },
      },
      {
        title: "P7",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "r3", name: "r3" },
      },
      {
        title: "P8",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "AnouncementFlow", name: "AnouncementFlow" },
      },
      {
        title: "S2",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "AnouncementFlow", name: "AnouncementFlow" },
      },
    ],
    11: [
      {
        title: "P1",
        criteria: "sentence",
        template: "simple",
        mechanism: { id: "AnouncementFlow", name: "AnouncementFlow" },
      },
      {
        title: "P2",
        criteria: "sentence",
        template: "simple",
        mechanism: { id: "AnouncementFlow", name: "AnouncementFlow" },
      },
      {
        title: "P3",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "askMore", name: "askMore" },
      },
      {
        title: "P4",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "askMore", name: "askMore" },
      },
      {
        title: "S1",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "AnouncementFlow", name: "AnouncementFlow" },
      },
      {
        title: "P5",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "AnouncementFlow", name: "AnouncementFlow" },
      },
      {
        title: "P6",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "AnouncementFlow", name: "AnouncementFlow" },
      },
      {
        title: "P7",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "askMore", name: "askMore" },
      },
      {
        title: "P8",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "askMore", name: "askMore" },
      },
      {
        title: "S2",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "AnouncementFlow", name: "AnouncementFlow" },
      },
    ],
    12: [
      {
        title: "P1",
        criteria: "sentence",
        template: "simple",
        competency: "L1.1",
        mechanism: { id: "AnouncementFlow", name: "AnouncementFlow" },
      },
      {
        title: "P2",
        criteria: "sentence",
        template: "simple",
        mechanism: { id: "ReadAloudMcqM10", name: "ReadAloudMcqM10" },
      },
      {
        title: "P3",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "jumbledWord", name: "jumbledWord" },
      },
      {
        title: "P4",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "jumbledWord", name: "jumbledWord" },
      },
      {
        title: "S1",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "AnouncementFlow", name: "AnouncementFlow" },
      },
      {
        title: "P5",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "AnouncementFlow", name: "AnouncementFlow" },
      },
      {
        title: "P6",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "ReadAloudMcqM10", name: "ReadAloudMcqM10" },
      },
      {
        title: "P7",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "jumbledWord", name: "jumbledWord" },
      },
      {
        title: "P8",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "jumbledWord", name: "jumbledWord" },
      },
      {
        title: "S2",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "AnouncementFlow", name: "AnouncementFlow" },
      },
    ],
    13: [
      {
        title: "P1",
        criteria: "sentence",
        template: "simple",
        mechanism: { id: "ReadAloudMcqM10", name: "ReadAloudMcqM10" },
      },
      {
        title: "P2",
        criteria: "sentence",
        template: "simple",
        mechanism: { id: "WhatsMissing", name: "WhatsMissing" },
      },
      {
        title: "P3",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "arrangePicture", name: "arrangePicture" },
      },
      {
        title: "P4",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "McqFlow", name: "McqFlow" },
      },
      {
        title: "S1",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "ReadAloudMcqM10", name: "ReadAloudMcqM10" },
      },
      {
        title: "P5",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "ReadAloudMcqM10", name: "ReadAloudMcqM10" },
      },
      {
        title: "P6",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "WhatsMissing", name: "WhatsMissing" },
      },
      {
        title: "P7",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "arrangePicture", name: "arrangePicture" },
      },
      {
        title: "P8",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "AnouncementFlow", name: "AnouncementFlow" },
      },
      {
        title: "S2",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "ReadAloudMcqM10", name: "ReadAloudMcqM10" },
      },
    ],
    14: [
      {
        title: "P1",
        criteria: "sentence",
        template: "simple",
        mechanism: { id: "askMore", name: "askMore" },
      },
      {
        title: "P2",
        criteria: "sentence",
        template: "simple",
        mechanism: { id: "askMore", name: "askMore" },
      },
      {
        title: "P3",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "askMore", name: "askMore" },
      },
      {
        title: "P4",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "askMore", name: "askMore" },
      },
      {
        title: "S1",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "askMore", name: "askMore" },
      },
      {
        title: "P5",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "askMore", name: "askMore" },
      },
      {
        title: "P6",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "askMore", name: "askMore" },
      },
      {
        title: "P7",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "askMore", name: "askMore" },
      },
      {
        title: "P8",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "askMore", name: "askMore" },
      },
      {
        title: "S2",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "askMore", name: "askMore" },
      },
    ],
    15: [
      {
        title: "P1",
        criteria: "sentence",
        template: "simple",
        mechanism: { id: "askMore", name: "askMore" },
      },
      {
        title: "P2",
        criteria: "sentence",
        template: "simple",
        mechanism: { id: "jumbledWord", name: "jumbledWord" },
      },
      {
        title: "P3",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "r3", name: "r3" },
      },
      {
        title: "P4",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "r3", name: "r3" },
      },
      {
        title: "S1",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "askMore", name: "askMore" },
      },
      {
        title: "P5",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "askMore", name: "askMore" },
      },
      {
        title: "P6",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "askMore", name: "askMore" },
      },
      {
        title: "P7",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "r3", name: "r3" },
      },
      {
        title: "P8",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "McqFlow", name: "McqFlow" },
      },
      {
        title: "S2",
        criteria: "paragraph",
        template: "simple",
        mechanism: { id: "AnouncementFlow", name: "AnouncementFlow" },
      },
    ],
  },
  ta: {
    B: [
      {
        title: "P1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L1",
        storyMode: true,
        multilingual: true,
      },
      {
        title: "P2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L2",
        multilingual: true,
      },
      {
        title: "P3",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P1",
        multilingual: true,
      },
      {
        title: "P4",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P2",
        multilingual: true,
      },
      {
        title: "S1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_S1",
        multilingual: true,
      },
      {
        title: "P5",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L3",
        multilingual: true,
      },
      {
        title: "P6",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L4",
        multilingual: true,
      },
      {
        title: "P7",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P3",
        multilingual: true,
      },
      {
        title: "P8",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P4",
        multilingual: true,
      },
      {
        title: "S2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_S2",
        multilingual: true,
      },
    ],
    0: [
      { title: "P1", criteria: "word", template: "simple" },
      { title: "P2", criteria: "word", template: "simple" },
      { title: "P3", criteria: "word", template: "simple" },
      { title: "P4", criteria: "word", template: "simple" },
      { title: "S1", criteria: "word", template: "simple" },
      { title: "P5", criteria: "word", template: "simple" },
      { title: "P6", criteria: "word", template: "simple" },
      { title: "P7", criteria: "word", template: "simple" },
      { title: "P8", criteria: "word", template: "simple" },
      { title: "S2", criteria: "word", template: "simple" },
    ],
    1: [
      { title: "P1", criteria: "word", template: "simple" },
      { title: "P2", criteria: "word", template: "simple" },
      { title: "P3", criteria: "word", template: "simple" },
      { title: "P4", criteria: "word", template: "simple" },
      { title: "S1", criteria: "word", template: "simple" },
      { title: "P5", criteria: "word", template: "simple" },
      { title: "P6", criteria: "word", template: "simple" },
      { title: "P7", criteria: "word", template: "simple" },
      { title: "P8", criteria: "word", template: "simple" },
      { title: "S2", criteria: "word", template: "simple" },
    ],
    2: [
      { title: "P1", criteria: "word", template: "simple" },
      { title: "P2", criteria: "word", template: "simple" },
      { title: "P3", criteria: "word", template: "simple" },
      { title: "P4", criteria: "word", template: "simple" },
      { title: "S1", criteria: "word", template: "simple" },
      { title: "P5", criteria: "word", template: "simple" },
      { title: "P6", criteria: "word", template: "simple" },
      { title: "P7", criteria: "word", template: "simple" },
      { title: "P8", criteria: "word", template: "simple" },
      { title: "S2", criteria: "word", template: "simple" },
    ],
    3: [
      { title: "P1", criteria: "word", template: "simple" },
      { title: "P2", criteria: "word", template: "simple" },
      { title: "P3", criteria: "sentence", template: "simple" },
      { title: "P4", criteria: "sentence", template: "simple" },
      { title: "S1", criteria: "sentence", template: "simple" },
      { title: "P5", criteria: "sentence", template: "simple" },
      { title: "P6", criteria: "sentence", template: "simple" },
      { title: "P7", criteria: "sentence", template: "simple" },
      { title: "P8", criteria: "sentence", template: "simple" },
      { title: "S2", criteria: "sentence", template: "simple" },
    ],
    4: [
      { title: "P1", criteria: "word", template: "simple" },
      { title: "P2", criteria: "word", template: "simple" },
      { title: "P3", criteria: "sentence", template: "simple" },
      { title: "P4", criteria: "sentence", template: "simple" },
      { title: "S1", criteria: "sentence", template: "simple" },
      { title: "P5", criteria: "sentence", template: "simple" },
      { title: "P6", criteria: "sentence", template: "simple" },
      { title: "P7", criteria: "sentence", template: "simple" },
      { title: "P8", criteria: "sentence", template: "simple" },
      { title: "S2", criteria: "sentence", template: "simple" },
    ],
    5: [
      { title: "P1", criteria: "sentence", template: "simple" },
      { title: "P2", criteria: "sentence", template: "simple" },
      { title: "P3", criteria: "sentence", template: "simple" },
      { title: "P4", criteria: "sentence", template: "simple" },
      { title: "S1", criteria: "sentence", template: "simple" },
      { title: "P5", criteria: "sentence", template: "simple" },
      { title: "P6", criteria: "sentence", template: "simple" },
      { title: "P7", criteria: "sentence", template: "simple" },
      { title: "P8", criteria: "sentence", template: "simple" },
      { title: "S2", criteria: "sentence", template: "simple" },
    ],
    6: [
      { title: "P1", criteria: "sentence", template: "simple" },
      { title: "P2", criteria: "sentence", template: "simple" },
      { title: "P3", criteria: "paragraph", template: "simple" },
      { title: "P4", criteria: "paragraph", template: "simple" },
      { title: "S1", criteria: "paragraph", template: "simple" },
      { title: "P5", criteria: "sentence", template: "simple" },
      { title: "P6", criteria: "paragraph", template: "simple" },
      { title: "P7", criteria: "paragraph", template: "simple" },
      { title: "P8", criteria: "paragraph", template: "simple" },
      { title: "S2", criteria: "paragraph", template: "simple" },
    ],
    7: [
      { title: "P1", criteria: "sentence", template: "simple" },
      { title: "P2", criteria: "sentence", template: "simple" },
      { title: "P3", criteria: "paragraph", template: "simple" },
      { title: "P4", criteria: "paragraph", template: "simple" },
      { title: "S1", criteria: "paragraph", template: "simple" },
      { title: "P5", criteria: "paragraph", template: "simple" },
      { title: "P6", criteria: "paragraph", template: "simple" },
      { title: "P7", criteria: "paragraph", template: "simple" },
      { title: "P8", criteria: "paragraph", template: "simple" },
      { title: "S2", criteria: "paragraph", template: "simple" },
    ],
    8: [
      { title: "P1", criteria: "sentence", template: "simple" },
      { title: "P2", criteria: "sentence", template: "simple" },
      { title: "P3", criteria: "paragraph", template: "simple" },
      { title: "P4", criteria: "paragraph", template: "simple" },
      { title: "S1", criteria: "paragraph", template: "simple" },
      { title: "P5", criteria: "paragraph", template: "simple" },
      { title: "P6", criteria: "paragraph", template: "simple" },
      { title: "P7", criteria: "paragraph", template: "simple" },
      { title: "P8", criteria: "paragraph", template: "simple" },
      { title: "S2", criteria: "paragraph", template: "simple" },
    ],
    9: [
      { title: "P1", criteria: "sentence", template: "simple" },
      { title: "P2", criteria: "sentence", template: "simple" },
      { title: "P3", criteria: "paragraph", template: "simple" },
      { title: "P4", criteria: "paragraph", template: "simple" },
      { title: "S1", criteria: "paragraph", template: "simple" },
      { title: "P5", criteria: "paragraph", template: "simple" },
      { title: "P6", criteria: "paragraph", template: "simple" },
      { title: "P7", criteria: "paragraph", template: "simple" },
      { title: "P8", criteria: "paragraph", template: "simple" },
      { title: "S2", criteria: "paragraph", template: "simple" },
    ],
  },
  hi: {
    B: [
      {
        title: "P1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L1",
        storyMode: true,
        multilingual: true,
      },
      {
        title: "P2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L2",
        multilingual: true,
      },
      {
        title: "P3",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P1",
        multilingual: true,
      },
      {
        title: "P4",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P2",
        multilingual: true,
      },
      {
        title: "S1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_S1",
        multilingual: true,
      },
      {
        title: "P5",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L3",
        multilingual: true,
      },
      {
        title: "P6",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L4",
        multilingual: true,
      },
      {
        title: "P7",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P3",
        multilingual: true,
      },
      {
        title: "P8",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P4",
        multilingual: true,
      },
      {
        title: "S2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_S2",
        multilingual: true,
      },
    ],
    F1: [
      // Learn 1 - Letter Train
      {
        title: "L1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L1",
        multilingual: false,
        mechanism: { id: "letterTrain", name: "letterTrain" },
        customLetters: ["अ", "आ", "इ", "ई", "उ"],
        contentCount: 10,
      },
      // Practice 1 - Letter Hunt (1 level, 10 content)
      {
        title: "P1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L2",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 1,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Learn 2 - Letter Train
      {
        title: "L2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P1",
        multilingual: false,
        mechanism: { id: "letterTrain", name: "letterTrain" },
        customLetters: ["ऊ", "ऋ", "ए", "ऐ", "ओ"],
        contentCount: 10,
      },
      // Practice 2 - Letter Hunt (1 level, 10 content)
      {
        title: "P2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P2",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 2,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Learn 3 - Letter Train
      {
        title: "L3",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L3",
        multilingual: false,
        mechanism: { id: "letterTrain", name: "letterTrain" },
        customLetters: ["औ", "अं", "क", "ख", "ग"],
        contentCount: 10,
      },
      // Practice 3 - Letter Hunt (1 level, 10 content)
      {
        title: "P3",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L4",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 3,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Apply 1 - Letter Hunt (3 levels, 13 content per level, showcase mode)
      {
        title: "A1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P3",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 1,
        letterHuntEndLevel: 3,
        letterHuntContentCount: 13,
        isShowcase: true,
        applyStep: 1,
        contentCount: 30,
        failRedirect: "L1", // If fail at any level, go to Learn 1
        passRedirect: "L4", // If pass all levels, go to Learn 4
      },
      // Learn 4 - Letter Train
      {
        title: "L4",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P4",
        multilingual: false,
        mechanism: { id: "letterTrain", name: "letterTrain" },
        customLetters: ["घ", "च", "छ", "ज", "झ"],
        contentCount: 10,
      },
      // Practice 4 - Letter Hunt (1 level, 10 content)
      {
        title: "P4",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P5",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 4,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Learn 5 - Letter Train
      {
        title: "L5",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L5",
        multilingual: false,
        mechanism: { id: "letterTrain", name: "letterTrain" },
        customLetters: ["ट", "ठ", "ड", "ढ", "ण"],
        contentCount: 10,
      },
      // Practice 5 - Letter Hunt (1 level, 10 content)
      {
        title: "P5",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L6",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 5,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Learn 6 - Letter Train
      {
        title: "L6",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P6",
        multilingual: false,
        mechanism: { id: "letterTrain", name: "letterTrain" },
        customLetters: ["त", "थ", "द", "ध", "न"],
        contentCount: 10,
      },
      // Practice 6 - Letter Hunt (1 level, 10 content)
      {
        title: "P6",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P7",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 6,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Apply 2 - Letter Hunt (3 levels, 13 content per level, showcase mode)
      {
        title: "A2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P8",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 4,
        letterHuntEndLevel: 6,
        letterHuntContentCount: 13,
        isShowcase: true,
        applyStep: 2,
        contentCount: 30,
        failRedirect: "L4", // If fail at any level, go to Learn 4
        passRedirect: "L7", // If pass all levels, go to Learn 7
      },
      // Learn 7 - Letter Train
      {
        title: "L7",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P9",
        multilingual: false,
        mechanism: { id: "letterTrain", name: "letterTrain" },
        customLetters: ["प", "फ", "ब", "भ", "म"],
        contentCount: 10,
      },
      // Practice 7 - Letter Hunt (1 level, 10 content)
      {
        title: "P7",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P10",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 7,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Learn 8 - Letter Train
      {
        title: "L8",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P11",
        multilingual: false,
        mechanism: { id: "letterTrain", name: "letterTrain" },
        customLetters: ["य", "र", "ल", "व", "श"],
        contentCount: 10,
      },
      // Practice 8 - Letter Hunt (1 level, 10 content)
      {
        title: "P8",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P12",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 8,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Learn 9 - Letter Train
      {
        title: "L9",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P13",
        multilingual: false,
        mechanism: { id: "letterTrain", name: "letterTrain" },
        customLetters: ["ष", "स", "ह", "क्ष", "त्र"],
        contentCount: 10,
      },
      // Practice 9 - Letter Hunt (1 level, 10 content)
      {
        title: "P9",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P14",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 9,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Apply 3 - Letter Hunt (3 levels, 13 content per level, showcase mode)
      {
        title: "A3",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P15",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 7,
        letterHuntEndLevel: 9,
        letterHuntContentCount: 13,
        isShowcase: true,
        applyStep: 3,
        contentCount: 30,
        failRedirect: "L7", // If fail at any level, go to Learn 7
        passRedirect: "F2", // If pass all levels, go to F2
      },
    ],
    F2: [
      // Learn 1 - Syllable Clap/Letter Train (English) or Barakadi (Indic)
      {
        title: "L1",
        contentCount: 10,
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L1",
        multilingual: false,
        mechanism: { id: "barakhadi", name: "barakhadi" }, // For English, use LetterTrain; for Indic, will use Barakhadi
        customLetters: ["कार", "रात", "पिता", "किला", "तीर"], // Placeholder - adjust based on F2 requirements
      },
      // Practice 1 - Letter Hunt (1 level, 10 content)
      {
        title: "P1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L2",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 10,
        letterHuntContentCount: 10,
        contentCount: 10,
        // customLetters: ["In", "The", "On", "An", "Am"],
      },
      // Learn 2 - Syllable Clap/Letter Hunt (English) or Barakadi (Indic)
      {
        title: "L2",
        contentCount: 10,
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P1",
        multilingual: false,
        mechanism: { id: "barakhadi", name: "barakhadi" }, // For English, use LetterTrain; for Indic, will use Barakhadi
        customLetters: ["गीत", "सुख", "रुक", "मुख", "फूल"], // Placeholder - adjust based on F2 requirements
      },
      // Practice 2 - Letter Hunt (1 level, 10 content)
      {
        title: "P2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P2",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        // customLetters: ["At", "It", "He", "She", "His"],
        multilingual: false,
        letterHuntLevel: 11,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Learn 3 - Syllable Clap/Letter Hunt (English) or Barakadi (Indic)
      {
        title: "L3",
        contentCount: 10,
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L3",
        multilingual: false,
        mechanism: { id: "barakhadi", name: "barakhadi" }, // For English, use LetterTrain; for Indic, will use Barakhadi
        customLetters: ["रूह", "गृह", "कृपा", "तेल", "केला"], // Placeholder - adjust based on F2 requirements
      },
      // Practice 3 - Letter Hunt (1 level, 10 content)
      {
        title: "P3",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L4",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        // customLetters: ["The", "Is", "Are", "Or", "Up", "On"],
        multilingual: false,
        letterHuntLevel: 12,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Apply 1 - Letter Hunt (3 levels, 13 content per level, showcase mode)
      {
        title: "A1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P3",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 10,
        letterHuntEndLevel: 12,
        letterHuntContentCount: 13,
        isShowcase: true,
        applyStep: 1,
        contentCount: 30,
        failRedirect: "L1", // If fail at any level, go to Learn 1
        passRedirect: "L4", // If pass all levels, go to Learn 4
      },
      // Learn 4 - Syllable Clap/Letter Hunt (English) or Barakadi (Indic)
      {
        title: "L4",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P4",
        multilingual: false,
        mechanism: { id: "barakhadi", name: "barakhadi" },
        customLetters: ["बैठ", "कैसे", "शोर", "मोर", "कौन"], // Placeholder - adjust based on F2 requirements
        contentCount: 10,
      },
      // Practice 4 - Letter Hunt (1 level, 10 content)
      {
        title: "P4",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P5",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        // customLetters: ["All", "In", "Ter", "Ing", "Up", "Him"],
        multilingual: false,
        letterHuntLevel: 13,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Learn 5 - Syllable Clap/Letter Hunt (English) or Barakadi (Indic)
      {
        title: "L5",
        contentCount: 10,
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P6",
        multilingual: false,
        mechanism: { id: "barakhadi", name: "barakhadi" },
        customLetters: ["मौज", "हंस", "नमः", "पानी", "रुचि"], // Placeholder - adjust based on F2 requirements
      },
      // Practice 5 - Letter Hunt (1 level, 10 content)
      {
        title: "P5",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P7",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 14,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Learn 6 - Syllable Clap/Letter Hunt (English) or Barakadi (Indic)
      {
        title: "L6",
        contentCount: 10,
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P8",
        multilingual: false,
        mechanism: { id: "barakhadi", name: "barakhadi" }, // For English, use LetterTrain; for Indic, will use Barakhadi
        customLetters: ["सामने", "शुरू", "होगा", "दिशा", "कितने"], // Placeholder - adjust based on F2 requirements
      },
      // Practice 6 - Letter Hunt (1 level, 10 content)
      {
        title: "P6",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P9",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 15,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Apply 2 - Letter Hunt (3 levels, 13 content per level, showcase mode)
      {
        title: "A2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P10",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 13,
        letterHuntEndLevel: 15,
        letterHuntContentCount: 13,
        isShowcase: true,
        applyStep: 2,
        contentCount: 30,
        failRedirect: "L4", // If fail at any level, go to Learn 4
        passRedirect: "L7", // If pass all levels, go to Learn 7
      },
      // Learn 7 - Syllable Clap/Letter Hunt (English) or Barakadi (Indic)
      {
        title: "L7",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P11",
        multilingual: false,
        mechanism: { id: "barakhadi", name: "barakhadi" },
        customLetters: ["चिड़िया", "सुना", "रुपया", "कविता", "मिला"], // Placeholder - adjust based on F2 requirements
        contentCount: 10,
      },
      // Practice 7 - Letter Hunt (1 level, 10 content)
      {
        title: "P7",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P12",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 16,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Learn 8 - Syllable Clap/Letter Hunt (English) or Barakadi (Indic)
      {
        title: "L8",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P13",
        multilingual: false,
        mechanism: { id: "barakhadi", name: "barakhadi" },
        contentCount: 10,
        customLetters: ["सोमारू", "पहेली", "कहानी", "तोसिया", "बारिश"], // Placeholder - adjust based on F2 requirements
      },
      // Practice 8 - Letter Hunt (1 level, 10 content)
      {
        title: "P8",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P14",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 17,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Learn 9 - Syllable Clap/Letter Hunt (English) or Barakadi (Indic)
      {
        title: "L9",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P15",
        multilingual: false,
        mechanism: { id: "barakhadi", name: "barakhadi" },
        contentCount: 10,
        customLetters: ["कटोरी", "थाली", "मुझे", "तैरना", "पिताजी"], // Placeholder - adjust based on F2 requirements
      },
      // Practice 9 - Letter Hunt (1 level, 10 content)
      {
        title: "P9",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P16",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 18,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Apply 3 - Letter Hunt (3 levels, 13 content per level, showcase mode)
      {
        title: "A3",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P17",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 16,
        letterHuntEndLevel: 18,
        letterHuntContentCount: 13,
        isShowcase: true,
        applyStep: 3,
        contentCount: 30,
        failRedirect: "L7", // If fail at any level, go to Learn 7
        passRedirect: "F3", // If pass all levels, go to F3
      },
    ],
    F3: [
      // Practice 1 - Letter Speed (Letter Launcher) - Alphabet sets
      {
        title: "P1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_P1",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: false,
        contentType: "letter", // Alphabet sets
        letterLauncherLevel: 19,
        letterLauncherContentCount: 10,
        contentCount: 10,
      },
      // Practice 2 - Letter Speed (Letter Launcher) - Alphabet sets
      {
        title: "P2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_P2",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: false,
        contentType: "letter",
        letterLauncherLevel: 20,
        letterLauncherContentCount: 10,
        contentCount: 10,
      },
      // Practice 3 - Letter Speed (Letter Launcher) - Alphabet sets
      {
        title: "P3",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_P3",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: false,
        contentType: "letter",
        letterLauncherLevel: 21,
        letterLauncherContentCount: 10,
        contentCount: 10,
      },
      // Practice 4 - Letter Speed (Letter Launcher) - Alphabet sets
      {
        title: "P4",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_P4",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: false,
        contentType: "letter",
        letterLauncherLevel: 20,
        letterLauncherContentCount: 10,
        contentCount: 10,
      },
      // Practice 5 - Letter Speed (Letter Launcher) - Alphabet sets
      {
        title: "P5",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_P5",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: false,
        contentType: "letter",
        letterLauncherLevel: 21,
        letterLauncherContentCount: 10,
        contentCount: 10,
      },
      // Apply 1 - Letter Speed (Letter Launcher) 3 levels + Memory Challenge 3 levels
      {
        title: "A1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_A1",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: false,
        contentType: "letter",
        letterLauncherLevel: 19,
        letterLauncherEndLevel: 21,
        letterLauncherContentCount: 20,
        isShowcase: true,
        applyStep: 1,
        contentCount: 35, // 20 letterLauncher + 15 memoryChallenge (3 levels × 5 sequences)
        failRedirect: "P1", // If fail at any level, go to Practice 1
        passRedirect: "P6", // If pass all levels, go to Practice 6
        // After Letter Launcher completes, show Memory Challenge
        memoryChallengeLevel: 19,
        memoryChallengeEndLevel: 21,
        memoryChallengeContentCount: 5, // 5 sequences per level
      },
      // Practice 6 - Syllable Speed (Letter Launcher) - Syllable sets
      {
        title: "P6",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_P6",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: false,
        contentType: "syllable", // Syllable sets
        letterLauncherLevel: 22,
        letterLauncherContentCount: 10,
        contentCount: 10,
      },
      // Practice 7 - Syllable Speed (Letter Launcher) - Syllable sets
      {
        title: "P7",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_P7",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: false,
        contentType: "syllable",
        letterLauncherLevel: 23,
        letterLauncherContentCount: 10,
        contentCount: 10,
      },
      // Practice 8 - Syllable Speed (Letter Launcher) - Syllable sets
      {
        title: "P8",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_P8",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: false,
        contentType: "syllable",
        letterLauncherLevel: 24,
        letterLauncherContentCount: 10,
        contentCount: 10,
      },
      // Practice 9 - Syllable Speed (Letter Launcher) - Syllable sets
      {
        title: "P9",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_P9",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: false,
        contentType: "syllable",
        letterLauncherLevel: 23,
        letterLauncherContentCount: 10,
        contentCount: 10,
      },
      // Practice 10 - Syllable Speed (Letter Launcher) - Syllable sets
      {
        title: "P10",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_P10",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: false,
        contentType: "syllable",
        letterLauncherLevel: 24,
        letterLauncherContentCount: 10,
        contentCount: 10,
      },
      // Apply 2 - Syllable Speed (Letter Launcher) 1 level + Memory Challenge 3 levels + Read Aloud
      {
        title: "A2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_A2",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: false,
        contentType: "syllable",
        letterLauncherLevel: 22,
        letterLauncherEndLevel: 24,
        letterLauncherContentCount: 20,
        isShowcase: true,
        applyStep: 2,
        contentCount: 45, // 20 letterLauncher + 15 memoryChallenge (3 levels × 5 sequences) + 10 readAloud
        failRedirect: "P6", // If fail at any level, go to Practice 6
        passRedirect: "complete", // If pass all levels, complete F3
        // After Letter Launcher completes, show Memory Challenge
        memoryChallengeLevel: 22,
        memoryChallengeEndLevel: 24,
        memoryChallengeContentCount: 5, // 5 sequences per level
        // After Memory Challenge completes, show Read Aloud
        readAloudContentCount: 10, // 10 simple root words
      },
    ],
    0: [
      { title: "P1", criteria: "word", template: "simple" },
      { title: "P2", criteria: "word", template: "simple" },
      { title: "P3", criteria: "word", template: "simple" },
      { title: "P4", criteria: "word", template: "simple" },
      { title: "S1", criteria: "word", template: "simple" },
      { title: "P5", criteria: "word", template: "simple" },
      { title: "P6", criteria: "word", template: "simple" },
      { title: "P7", criteria: "word", template: "simple" },
      { title: "P8", criteria: "word", template: "simple" },
      { title: "S2", criteria: "word", template: "simple" },
    ],
    1: [
      {
        title: "P1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M1_L1",
        contentCount: 10,
        // storyMode: true,
        mechanism: { id: "mechanic_7", name: "formAWord2" },
        multilingual: false,
      },
      {
        title: "P2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M1_L2",
        contentCount: 10,
        mechanism: { id: "mechanic_7", name: "formAWord2" },
        multilingual: false,
      },
      {
        title: "P3",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M1_P1",
        contentCount: 10,
        mechanism: { id: "soundHunt", name: "soundHunt" },
        multilingual: false,
      },
      {
        title: "P4",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M1_P2",
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "S1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M1_S1",
        contentCount: 10,
        mechanism: { id: "soundHuntS1Combined", name: "soundHuntS1Combined" },
        multilingual: false,
      },
      {
        title: "P5",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M1_L3",
        contentCount: 10,
        mechanism: { id: "mechanic_7", name: "formAWord2" },
        multilingual: false,
      },
      {
        title: "P6",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M1_L4",
        contentCount: 10,
        mechanism: { id: "mechanic_7", name: "formAWord2" },
        multilingual: false,
      },
      {
        title: "P7",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M1_P3",
        mechanism: { id: "soundHunt", name: "soundHunt" },
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "P8",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M1_P4",
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "S2",
        criteria: "word",
        template: "simple",
        mechanism: { id: "soundHuntS1Combined", name: "soundHuntS1Combined" },
        contentCount: 10,
        tags: "CEFR_M1_S2",
        multilingual: false,
      },
    ],
    2: [
      {
        title: "P1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M2_L1",
        mechanism: { id: "bingo_card", name: "bingoCard" },
        //storyMode: true,
        multilingual: false,
      },
      {
        title: "P2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M2_L2",
        mechanism: { id: "bingo_card", name: "bingoCard" },
        multilingual: false,
      },
      {
        title: "P3",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M2_P1",
        // mechanism: { id: "soundHunt", name: "soundHunt" },
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "P4",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M2_P2",
        mechanism: { id: "soundHunt", name: "soundHunt" },
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "S1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M2_S1",
        mechanism: { id: "soundHuntS1Combined", name: "soundHuntS1Combined" },
        multilingual: false,
      },
      {
        title: "P5",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M2_L3",
        mechanism: { id: "bingo_card", name: "bingoCard" },
        multilingual: false,
      },
      {
        title: "P6",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M2_L4",
        mechanism: { id: "bingo_card", name: "bingoCard" },
        multilingual: false,
      },
      {
        title: "P7",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M2_P3",
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "P8",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M2_P4",
        mechanism: { id: "soundHunt", name: "soundHunt" },
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "S2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M2_S2",
        mechanism: { id: "soundHuntS1Combined", name: "soundHuntS1Combined" },
        multilingual: false,
      },
    ],
    3: [
      {
        title: "P1",
        criteria: "sentence",
        template: "simple",
        tags: "CEFR_M3_L1",
        //storyMode: true,
        mechanism: { id: "PhrasesInAction", name: "PhrasesInAction" },
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "P2",
        criteria: "sentence",
        template: "simple",
        tags: "CEFR_M3_L2",
        mechanism: { id: "PhrasesInAction", name: "PhrasesInAction" },
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "P3",
        criteria: "sentence",
        template: "simple",
        tags: "CEFR_M3_P1",
        // mechanism: { id: "PhrasesInAction", name: "PhrasesInAction" },
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "P4",
        criteria: "sentence",
        template: "simple",
        tags: "CEFR_M3_P2",
        //competency: "L1.1",
        // mechanism: { id: "PhrasesInAction", name: "PhrasesInAction" },
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "S1",
        criteria: "sentence",
        template: "simple",
        tags: "CEFR_M3_S1",
        mechanism: { id: "soundHuntS1Combined", name: "soundHuntS1Combined" },
      },
      {
        title: "P5",
        criteria: "sentence",
        template: "simple",
        tags: "CEFR_M3_L3",
        mechanism: { id: "PhrasesInAction", name: "PhrasesInAction" },
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "P6",
        criteria: "sentence",
        template: "simple",
        tags: "CEFR_M3_L4",
        mechanism: { id: "PhrasesInAction", name: "PhrasesInAction" },
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "P7",
        criteria: "sentence",
        template: "simple",
        tags: "CEFR_M3_P3",
        // mechanism: { id: "PhrasesInAction", name: "PhrasesInAction" },
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "P8",
        criteria: "sentence",
        template: "simple",
        tags: "CEFR_M3_P4",
        //competency: "L1.1",
        // mechanism: { id: "PhrasesInAction", name: "PhrasesInAction" },
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "S2",
        criteria: "sentence",
        template: "simple",
        tags: "CEFR_M3_S2",
        mechanism: { id: "soundHuntS1Combined", name: "soundHuntS1Combined" },
      },
    ],
    4: [
      { title: "P1", criteria: "word", template: "simple" },
      { title: "P2", criteria: "word", template: "simple" },
      { title: "P3", criteria: "sentence", template: "simple" },
      { title: "P4", criteria: "sentence", template: "simple" },
      { title: "S1", criteria: "sentence", template: "simple" },
      { title: "P5", criteria: "sentence", template: "simple" },
      { title: "P6", criteria: "sentence", template: "simple" },
      { title: "P7", criteria: "sentence", template: "simple" },
      { title: "P8", criteria: "sentence", template: "simple" },
      { title: "S2", criteria: "sentence", template: "simple" },
    ],
    5: [
      { title: "P1", criteria: "sentence", template: "simple" },
      { title: "P2", criteria: "sentence", template: "simple" },
      { title: "P3", criteria: "sentence", template: "simple" },
      { title: "P4", criteria: "sentence", template: "simple" },
      { title: "S1", criteria: "sentence", template: "simple" },
      { title: "P5", criteria: "sentence", template: "simple" },
      { title: "P6", criteria: "sentence", template: "simple" },
      { title: "P7", criteria: "sentence", template: "simple" },
      { title: "P8", criteria: "sentence", template: "simple" },
      { title: "S2", criteria: "sentence", template: "simple" },
    ],
    6: [
      { title: "P1", criteria: "sentence", template: "simple" },
      { title: "P2", criteria: "sentence", template: "simple" },
      { title: "P3", criteria: "paragraph", template: "simple" },
      { title: "P4", criteria: "paragraph", template: "simple" },
      { title: "S1", criteria: "paragraph", template: "simple" },
      { title: "P5", criteria: "sentence", template: "simple" },
      { title: "P6", criteria: "paragraph", template: "simple" },
      { title: "P7", criteria: "paragraph", template: "simple" },
      { title: "P8", criteria: "paragraph", template: "simple" },
      { title: "S2", criteria: "paragraph", template: "simple" },
    ],
    7: [
      { title: "P1", criteria: "sentence", template: "simple" },
      { title: "P2", criteria: "sentence", template: "simple" },
      { title: "P3", criteria: "paragraph", template: "simple" },
      { title: "P4", criteria: "paragraph", template: "simple" },
      { title: "S1", criteria: "paragraph", template: "simple" },
      { title: "P5", criteria: "paragraph", template: "simple" },
      { title: "P6", criteria: "paragraph", template: "simple" },
      { title: "P7", criteria: "paragraph", template: "simple" },
      { title: "P8", criteria: "paragraph", template: "simple" },
      { title: "S2", criteria: "paragraph", template: "simple" },
    ],
    8: [
      { title: "P1", criteria: "sentence", template: "simple" },
      { title: "P2", criteria: "sentence", template: "simple" },
      { title: "P3", criteria: "paragraph", template: "simple" },
      { title: "P4", criteria: "paragraph", template: "simple" },
      { title: "S1", criteria: "paragraph", template: "simple" },
      { title: "P5", criteria: "paragraph", template: "simple" },
      { title: "P6", criteria: "paragraph", template: "simple" },
      { title: "P7", criteria: "paragraph", template: "simple" },
      { title: "P8", criteria: "paragraph", template: "simple" },
      { title: "S2", criteria: "paragraph", template: "simple" },
    ],
    9: [
      { title: "P1", criteria: "sentence", template: "simple" },
      { title: "P2", criteria: "sentence", template: "simple" },
      { title: "P3", criteria: "paragraph", template: "simple" },
      { title: "P4", criteria: "paragraph", template: "simple" },
      { title: "S1", criteria: "paragraph", template: "simple" },
      { title: "P5", criteria: "paragraph", template: "simple" },
      { title: "P6", criteria: "paragraph", template: "simple" },
      { title: "P7", criteria: "paragraph", template: "simple" },
      { title: "P8", criteria: "paragraph", template: "simple" },
      { title: "S2", criteria: "paragraph", template: "simple" },
    ],
  },
  kn: {
    B: [
      {
        title: "P1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L1",
        storyMode: true,
        multilingual: true,
      },
      {
        title: "P2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L2",
        multilingual: true,
      },
      {
        title: "P3",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P1",
        multilingual: true,
      },
      {
        title: "P4",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P2",
        multilingual: true,
      },
      {
        title: "S1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_S1",
        multilingual: true,
      },
      {
        title: "P5",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L3",
        multilingual: true,
      },
      {
        title: "P6",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L4",
        multilingual: true,
      },
      {
        title: "P7",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P3",
        multilingual: true,
      },
      {
        title: "P8",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P4",
        multilingual: true,
      },
      {
        title: "S2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_S2",
        multilingual: true,
      },
    ],
    F1: [
      // Learn 1 - Letter Train
      {
        title: "L1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L1",
        multilingual: false,
        mechanism: { id: "letterTrain", name: "letterTrain" },
        customLetters: ["ರ", "ಗ", "ಸ", "ದ", "ಅ"],
        contentCount: 10,
      },
      // Practice 1 - Letter Hunt (1 level, 10 content)
      {
        title: "P1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L2",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 1,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Learn 2 - Letter Train
      {
        title: "L2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P1",
        multilingual: false,
        mechanism: { id: "letterTrain", name: "letterTrain" },
        customLetters: ["ಜ", "ವ", "ಮ", "ಬ", "ನ"],
        contentCount: 10,
      },
      // Practice 2 - Letter Hunt (1 level, 10 content)
      {
        title: "P2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P2",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 2,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Learn 3 - Letter Train
      {
        title: "L3",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L3",
        multilingual: false,
        mechanism: { id: "letterTrain", name: "letterTrain" },
        customLetters: ["ಪ", "ಯ", "ಉ", "ಡ", "ಟ"],
        contentCount: 10,
      },
      // Practice 3 - Letter Hunt (1 level, 10 content)
      {
        title: "P3",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L4",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 3,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Apply 1 - Letter Hunt (3 levels, 13 content per level, showcase mode)
      {
        title: "A1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P3",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 1,
        letterHuntEndLevel: 3,
        letterHuntContentCount: 13,
        isShowcase: true,
        applyStep: 1,
        contentCount: 30,
        failRedirect: "L1", // If fail at any level, go to Learn 1
        passRedirect: "L4", // If pass all levels, go to Learn 4
      },
      // Learn 4 - Letter Train
      {
        title: "L4",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P4",
        multilingual: false,
        mechanism: { id: "letterTrain", name: "letterTrain" },
        customLetters: ["ಚ", "ಲ", "ಈ", "ಊ", "ಕ"],
        contentCount: 10,
      },
      // Practice 4 - Letter Hunt (1 level, 10 content)
      {
        title: "P4",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P5",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 4,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Learn 5 - Letter Train
      {
        title: "L5",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L5",
        multilingual: false,
        mechanism: { id: "letterTrain", name: "letterTrain" },
        customLetters: ["ಎ", "ಏ", "ಇ", "ಆ", "ತ"],
        contentCount: 10,
      },
      // Practice 5 - Letter Hunt (1 level, 10 content)
      {
        title: "P5",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L6",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 5,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Learn 6 - Letter Train
      {
        title: "L6",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P6",
        multilingual: false,
        mechanism: { id: "letterTrain", name: "letterTrain" },
        customLetters: ["ಳ", "ಓ", "ಔ", "ಹ", "ಶ"],
        contentCount: 10,
      },
      // Practice 6 - Letter Hunt (1 level, 10 content)
      {
        title: "P6",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P7",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 6,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Apply 2 - Letter Hunt (3 levels, 13 content per level, showcase mode)
      {
        title: "A2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P8",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 4,
        letterHuntEndLevel: 6,
        letterHuntContentCount: 13,
        isShowcase: true,
        applyStep: 2,
        contentCount: 30,
        failRedirect: "L4", // If fail at any level, go to Learn 4
        passRedirect: "L7", // If pass all levels, go to Learn 7
      },
      // Learn 7 - Letter Train
      {
        title: "L7",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P9",
        multilingual: false,
        mechanism: { id: "letterTrain", name: "letterTrain" },
        customLetters: ["ಷ", "ಐ", "ಋ", "ಣ", "ಛ"],
        contentCount: 10,
      },
      // Practice 7 - Letter Hunt (1 level, 10 content)
      {
        title: "P7",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P10",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 7,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Learn 8 - Letter Train
      {
        title: "L8",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P11",
        multilingual: false,
        mechanism: { id: "letterTrain", name: "letterTrain" },
        customLetters: ["ಒ", "ಧ", "ಥ", "ಢ", "ಭ"],
        contentCount: 10,
      },
      // Practice 8 - Letter Hunt (1 level, 10 content)
      {
        title: "P8",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P12",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 8,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Learn 9 - Letter Train
      {
        title: "L9",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P13",
        multilingual: false,
        mechanism: { id: "letterTrain", name: "letterTrain" },
        customLetters: ["ಘ", "ಠ", "ಫ", "ಝ", "ಖ"],
        contentCount: 10,
      },
      // Practice 9 - Letter Hunt (1 level, 10 content)
      {
        title: "P9",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P14",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 9,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Apply 3 - Letter Hunt (3 levels, 13 content per level, showcase mode)
      {
        title: "A3",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P15",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 7,
        letterHuntEndLevel: 9,
        letterHuntContentCount: 13,
        isShowcase: true,
        applyStep: 3,
        contentCount: 30,
        failRedirect: "L7", // If fail at any level, go to Learn 7
        passRedirect: "F2", // If pass all levels, go to F2
      },
    ],
    F2: [
      // Learn 1 - Syllable Clap/Letter Train (English) or Barakadi (Indic)
      {
        title: "L1",
        contentCount: 10,
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L1",
        multilingual: false,
        mechanism: { id: "barakhadi", name: "barakhadi" }, // For English, use LetterTrain; for Indic, will use Barakhadi
        customLetters: [
          "ಕಾಗೆ",
          "ಮಾಲೆ",
          "ಗಿಳಿ",
          "ಕಿಟಕಿ",
          "ಗುರು",
          "ಹುಲಿ",
          "ಮೂರು",
          "ಗೂಡು",
          "ಗೃಹ",
          "ಕೃತಿ",
        ], // Placeholder - adjust based on F2 requirements
      },
      // Practice 1 - Letter Hunt (1 level, 10 content)
      {
        title: "P1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L2",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 10,
        letterHuntContentCount: 10,
        contentCount: 10,
        // customLetters: ["In", "The", "On", "An", "Am"],
      },
      // Learn 2 - Syllable Clap/Letter Hunt (English) or Barakadi (Indic)
      {
        title: "L2",
        contentCount: 10,
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P1",
        multilingual: false,
        mechanism: { id: "barakhadi", name: "barakhadi" }, // For English, use LetterTrain; for Indic, will use Barakhadi
        customLetters: [
          "ಕೆರೆ",
          "ಮೆರೆ",
          "ದೇವಿ",
          "ವೇಷ",
          "ಕೈದಿ",
          "ಪೈರು",
          "ಹೊರೆ",
          "ಕೊಳೆ",
          "ಹೋರಿ",
          "ನೋಟು",
        ], // Placeholder - adjust based on F2 requirements
      },
      // Practice 2 - Letter Hunt (1 level, 10 content)
      {
        title: "P2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P2",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        // customLetters: ["At", "It", "He", "She", "His"],
        multilingual: false,
        letterHuntLevel: 11,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Learn 3 - Syllable Clap/Letter Hunt (English) or Barakadi (Indic)
      {
        title: "L3",
        contentCount: 10,
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L3",
        multilingual: false,
        mechanism: { id: "barakhadi", name: "barakhadi" }, // For English, use LetterTrain; for Indic, will use Barakhadi
        customLetters: [
          "ದೌಡು",
          "ಜೌಗು",
          "ಕಂಸ",
          "ನಂದಿ",
          "ಹಾವು",
          "ಬಿಳಿ",
          "ಹೊಗೆ",
          "ಕೆನೆ",
          "ಕೇಳು",
          "ನೌಕೆ",
        ], // Placeholder - adjust based on F2 requirements
      },
      // Practice 3 - Letter Hunt (1 level, 10 content)
      {
        title: "P3",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L4",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        // customLetters: ["The", "Is", "Are", "Or", "Up", "On"],
        multilingual: false,
        letterHuntLevel: 12,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Apply 1 - Letter Hunt (3 levels, 13 content per level, showcase mode)
      {
        title: "A1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P3",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 10,
        letterHuntEndLevel: 12,
        letterHuntContentCount: 13,
        isShowcase: true,
        applyStep: 1,
        contentCount: 30,
        failRedirect: "L1", // If fail at any level, go to Learn 1
        passRedirect: "L4", // If pass all levels, go to Learn 4
      },
      // Learn 4 - Syllable Clap/Letter Hunt (English) or Barakadi (Indic)
      {
        title: "L4",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P4",
        multilingual: false,
        mechanism: { id: "barakhadi", name: "barakhadi" },
        customLetters: [
          "ನಾಳೆ",
          "ಚೀಟಿ",
          "ಠೀವಿ",
          "ಸುಲಿ",
          "ಬೆವರು",
          "ಹೇರು",
          "ಹಾಡು",
          "ತೊರೆ",
          "ಚೇಳು",
          "ಗೇಟು",
        ], // Placeholder - adjust based on F2 requirements
        contentCount: 10,
      },
      // Practice 4 - Letter Hunt (1 level, 10 content)
      {
        title: "P4",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P5",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        // customLetters: ["All", "In", "Ter", "Ing", "Up", "Him"],
        multilingual: false,
        letterHuntLevel: 13,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Learn 5 - Syllable Clap/Letter Hunt (English) or Barakadi (Indic)
      {
        title: "L5",
        contentCount: 10,
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P6",
        multilingual: false,
        mechanism: { id: "barakhadi", name: "barakhadi" },
        customLetters: [
          "ಜೈಲು",
          "ಬಾಯಿ",
          "ಮೊರೆ",
          "ಡಾಬಾ",
          "ಗೋವು",
          "ಕುದಿಸು",
          "ಡೋಲು",
          "ಪೌಳಿ",
          "ಮೋರಿ",
          "ನೀರು",
        ], // Placeholder - adjust based on F2 requirements
      },
      // Practice 5 - Letter Hunt (1 level, 10 content)
      {
        title: "P5",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P7",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 14,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Learn 6 - Syllable Clap/Letter Hunt (English) or Barakadi (Indic)
      {
        title: "L6",
        contentCount: 10,
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P8",
        multilingual: false,
        mechanism: { id: "barakhadi", name: "barakhadi" }, // For English, use LetterTrain; for Indic, will use Barakhadi
        customLetters: [
          "ದೋಣಿ",
          "ದಾರಿ",
          "ಸೇರು",
          "ಲೈಲಾ",
          "ವೈರಿ",
          "ಕುರಿ",
          "ಗಾಡಿ",
          "ಸೌತೆ",
          "ಸಾರಿಗೆ",
          "ರಾಣಿ",
        ], // Placeholder - adjust based on F2 requirements
      },
      // Practice 6 - Letter Hunt (1 level, 10 content)
      {
        title: "P6",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P9",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 15,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Apply 2 - Letter Hunt (3 levels, 13 content per level, showcase mode)
      {
        title: "A2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P10",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 13,
        letterHuntEndLevel: 15,
        letterHuntContentCount: 13,
        isShowcase: true,
        applyStep: 2,
        contentCount: 30,
        failRedirect: "L4", // If fail at any level, go to Learn 4
        passRedirect: "L7", // If pass all levels, go to Learn 7
      },
      // Learn 7 - Syllable Clap/Letter Hunt (English) or Barakadi (Indic)
      {
        title: "L7",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P11",
        multilingual: false,
        mechanism: { id: "barakhadi", name: "barakhadi" },
        customLetters: [
          "ಬೇಸಿಗೆ",
          "ವೋಟು",
          "ತೊಲೆ",
          "ಯಾರಿಗೆ",
          "ಮೌನಿ",
          "ಸೌದೆ",
          "ತೌರು",
          "ಕೋಡು",
          "ಗೋಡೆ",
          "ಚೋಟು",
        ], // Placeholder - adjust based on F2 requirements
        contentCount: 10,
      },
      // Practice 7 - Letter Hunt (1 level, 10 content)
      {
        title: "P7",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P12",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 16,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Learn 8 - Syllable Clap/Letter Hunt (English) or Barakadi (Indic)
      {
        title: "L8",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P13",
        multilingual: false,
        mechanism: { id: "barakhadi", name: "barakhadi" },
        contentCount: 10,
        customLetters: [
          "ರೋಗಿ",
          "ಟೋಪಿ",
          "ತೋಟಿ",
          "ಕೈದು",
          "ಪೈಪು",
          "ಬೆಳೆ",
          "ವಾಸಿಸು",
          "ಮುದುಕ",
          "ಮೈಸೂರು",
          "ಜೋಗುಳ",
        ], // Placeholder - adjust based on F2 requirements
      },
      // Practice 8 - Letter Hunt (1 level, 10 content)
      {
        title: "P8",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P14",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 17,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Learn 9 - Syllable Clap/Letter Hunt (English) or Barakadi (Indic)
      {
        title: "L9",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P15",
        multilingual: false,
        mechanism: { id: "barakhadi", name: "barakhadi" },
        contentCount: 10,
        customLetters: [
          "ಗುಡಿಸು",
          "ಯುವತಿ",
          "ಜೊತೆಗೆ",
          "ಯೋಜಿಸು",
          "ಪಾಲಿಸು",
          "ಜಿನುಗು",
          "ಸಿರಿ",
          "ಚಿರತೆ",
          "ಸೈನಿಕ",
          "ಜೇನು",
        ], // Placeholder - adjust based on F2 requirements
      },
      // Practice 9 - Letter Hunt (1 level, 10 content)
      {
        title: "P9",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P16",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 18,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Apply 3 - Letter Hunt (3 levels, 13 content per level, showcase mode)
      {
        title: "A3",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P17",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 16,
        letterHuntEndLevel: 18,
        letterHuntContentCount: 13,
        isShowcase: true,
        applyStep: 3,
        contentCount: 30,
        failRedirect: "L7", // If fail at any level, go to Learn 7
        passRedirect: "F3", // If pass all levels, go to F3
      },
    ],
    F3: [
      // Practice 1 - Letter Speed (Letter Launcher) - Alphabet sets
      {
        title: "P1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_P1",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: false,
        contentType: "letter", // Alphabet sets
        letterLauncherLevel: 19,
        letterLauncherContentCount: 10,
        contentCount: 10,
      },
      // Practice 2 - Letter Speed (Letter Launcher) - Alphabet sets
      {
        title: "P2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_P2",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: false,
        contentType: "letter",
        letterLauncherLevel: 20,
        letterLauncherContentCount: 10,
        contentCount: 10,
      },
      // Practice 3 - Letter Speed (Letter Launcher) - Alphabet sets
      {
        title: "P3",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_P3",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: false,
        contentType: "letter",
        letterLauncherLevel: 21,
        letterLauncherContentCount: 10,
        contentCount: 10,
      },
      // Practice 4 - Letter Speed (Letter Launcher) - Alphabet sets
      {
        title: "P4",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_P4",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: false,
        contentType: "letter",
        letterLauncherLevel: 20,
        letterLauncherContentCount: 10,
        contentCount: 10,
      },
      // Practice 5 - Letter Speed (Letter Launcher) - Alphabet sets
      {
        title: "P5",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_P5",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: false,
        contentType: "letter",
        letterLauncherLevel: 21,
        letterLauncherContentCount: 10,
        contentCount: 10,
      },
      // Apply 1 - Letter Speed (Letter Launcher) 3 levels + Memory Challenge 3 levels
      {
        title: "A1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_A1",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: false,
        contentType: "letter",
        letterLauncherLevel: 19,
        letterLauncherEndLevel: 21,
        letterLauncherContentCount: 20,
        isShowcase: true,
        applyStep: 1,
        contentCount: 35, // 20 letterLauncher + 15 memoryChallenge (3 levels × 5 sequences)
        failRedirect: "P1", // If fail at any level, go to Practice 1
        passRedirect: "P6", // If pass all levels, go to Practice 6
        // After Letter Launcher completes, show Memory Challenge
        memoryChallengeLevel: 19,
        memoryChallengeEndLevel: 21,
        memoryChallengeContentCount: 5, // 5 sequences per level
      },
      // Practice 6 - Syllable Speed (Letter Launcher) - Syllable sets
      {
        title: "P6",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_P6",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: false,
        contentType: "syllable", // Syllable sets
        letterLauncherLevel: 22,
        letterLauncherContentCount: 10,
        contentCount: 10,
      },
      // Practice 7 - Syllable Speed (Letter Launcher) - Syllable sets
      {
        title: "P7",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_P7",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: false,
        contentType: "syllable",
        letterLauncherLevel: 23,
        letterLauncherContentCount: 10,
        contentCount: 10,
      },
      // Practice 8 - Syllable Speed (Letter Launcher) - Syllable sets
      {
        title: "P8",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_P8",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: false,
        contentType: "syllable",
        letterLauncherLevel: 24,
        letterLauncherContentCount: 10,
        contentCount: 10,
      },
      // Practice 9 - Syllable Speed (Letter Launcher) - Syllable sets
      {
        title: "P9",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_P9",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: false,
        contentType: "syllable",
        letterLauncherLevel: 23,
        letterLauncherContentCount: 10,
        contentCount: 10,
      },
      // Practice 10 - Syllable Speed (Letter Launcher) - Syllable sets
      {
        title: "P10",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_P10",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: false,
        contentType: "syllable",
        letterLauncherLevel: 24,
        letterLauncherContentCount: 10,
        contentCount: 10,
      },
      // Apply 2 - Syllable Speed (Letter Launcher) 1 level + Memory Challenge 3 levels + Read Aloud
      {
        title: "A2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_A2",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: false,
        contentType: "syllable",
        letterLauncherLevel: 22,
        letterLauncherEndLevel: 24,
        letterLauncherContentCount: 20,
        isShowcase: true,
        applyStep: 2,
        contentCount: 45, // 20 letterLauncher + 15 memoryChallenge (3 levels × 5 sequences) + 10 readAloud
        failRedirect: "P6", // If fail at any level, go to Practice 6
        passRedirect: "complete", // If pass all levels, complete F3
        // After Letter Launcher completes, show Memory Challenge
        memoryChallengeLevel: 22,
        memoryChallengeEndLevel: 24,
        memoryChallengeContentCount: 5, // 5 sequences per level
        // After Memory Challenge completes, show Read Aloud
        readAloudContentCount: 10, // 10 simple root words
      },
    ],
    0: [
      { title: "P1", criteria: "word", template: "simple" },
      { title: "P2", criteria: "word", template: "simple" },
      { title: "P3", criteria: "word", template: "simple" },
      { title: "P4", criteria: "word", template: "simple" },
      { title: "S1", criteria: "word", template: "simple" },
      { title: "P5", criteria: "word", template: "simple" },
      { title: "P6", criteria: "word", template: "simple" },
      { title: "P7", criteria: "word", template: "simple" },
      { title: "P8", criteria: "word", template: "simple" },
      { title: "S2", criteria: "word", template: "simple" },
    ],
    1: [
      {
        title: "P1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M1_L1",
        contentCount: 10,
        mechanism: { id: "mechanic_7", name: "formAWord2" },
        multilingual: false,
      },
      {
        title: "P2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M1_L2",
        contentCount: 10,
        mechanism: { id: "mechanic_7", name: "formAWord2" },
        multilingual: false,
      },
      {
        title: "P3",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M1_P1",
        contentCount: 10,
        mechanism: { id: "soundHunt", name: "soundHunt" },
        multilingual: false,
      },
      {
        title: "P4",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M1_P2",
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "S1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M1_S1",
        contentCount: 10,
        mechanism: { id: "soundHuntS1Combined", name: "soundHuntS1Combined" },
        multilingual: false,
      },
      {
        title: "P5",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M1_L3",
        contentCount: 10,
        mechanism: { id: "mechanic_7", name: "formAWord2" },
        multilingual: false,
      },
      {
        title: "P6",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M1_L4",
        contentCount: 10,
        mechanism: { id: "mechanic_7", name: "formAWord2" },
        multilingual: false,
      },
      {
        title: "P7",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M1_P3",
        mechanism: { id: "soundHunt", name: "soundHunt" },
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "P8",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M1_P4",
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "S2",
        criteria: "word",
        template: "simple",
        mechanism: { id: "soundHuntS1Combined", name: "soundHuntS1Combined" },
        contentCount: 10,
        tags: "CEFR_M1_S2",
        multilingual: false,
      },
    ],
    2: [
      {
        title: "P1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M2_L1",
        mechanism: { id: "bingo_card", name: "bingoCard" },
        //storyMode: true,
        multilingual: false,
      },
      {
        title: "P2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M2_L2",
        mechanism: { id: "bingo_card", name: "bingoCard" },
        multilingual: false,
      },
      {
        title: "P3",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M2_P1",
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "P4",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M2_P2",
        mechanism: { id: "soundHunt", name: "soundHunt" },
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "S1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M2_S1",
        mechanism: { id: "soundHuntS1Combined", name: "soundHuntS1Combined" },
        multilingual: false,
      },
      {
        title: "P5",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M2_L3",
        mechanism: { id: "bingo_card", name: "bingoCard" },
        multilingual: false,
      },
      {
        title: "P6",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M2_L4",
        mechanism: { id: "bingo_card", name: "bingoCard" },
        multilingual: false,
      },
      {
        title: "P7",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M2_P3",
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "P8",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M2_P4",
        mechanism: { id: "soundHunt", name: "soundHunt" },
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "S2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M2_S2",
        mechanism: { id: "soundHuntS1Combined", name: "soundHuntS1Combined" },
        multilingual: false,
      },
    ],
    3: [
      {
        title: "P1",
        criteria: "sentence",
        template: "simple",
        tags: "CEFR_M3_L1",
        //storyMode: true,
        mechanism: { id: "PhrasesInAction", name: "PhrasesInAction" },
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "P2",
        criteria: "sentence",
        template: "simple",
        tags: "CEFR_M3_L2",
        mechanism: { id: "PhrasesInAction", name: "PhrasesInAction" },
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "P3",
        criteria: "sentence",
        template: "simple",
        tags: "CEFR_M3_P1",
        // mechanism: { id: "PhrasesInAction", name: "PhrasesInAction" },
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "P4",
        criteria: "sentence",
        template: "simple",
        tags: "CEFR_M3_P2",
        //competency: "L1.1",
        // mechanism: { id: "PhrasesInAction", name: "PhrasesInAction" },
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "S1",
        criteria: "sentence",
        template: "simple",
        tags: "CEFR_M3_S1",
        mechanism: { id: "soundHuntS1Combined", name: "soundHuntS1Combined" },
      },
      {
        title: "P5",
        criteria: "sentence",
        template: "simple",
        tags: "CEFR_M3_L3",
        mechanism: { id: "PhrasesInAction", name: "PhrasesInAction" },
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "P6",
        criteria: "sentence",
        template: "simple",
        tags: "CEFR_M3_L4",
        mechanism: { id: "PhrasesInAction", name: "PhrasesInAction" },
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "P7",
        criteria: "sentence",
        template: "simple",
        tags: "CEFR_M3_P3",
        // mechanism: { id: "PhrasesInAction", name: "PhrasesInAction" },
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "P8",
        criteria: "sentence",
        template: "simple",
        tags: "CEFR_M3_P4",
        //competency: "L1.1",
        // mechanism: { id: "PhrasesInAction", name: "PhrasesInAction" },
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "S2",
        criteria: "sentence",
        template: "simple",
        tags: "CEFR_M3_S2",
        mechanism: { id: "soundHuntS1Combined", name: "soundHuntS1Combined" },
      },
    ],
    4: [
      {
        title: "P1",
        criteria: "sentence",
        template: "simple",
        tags: "M4_KN_READ",
      },
      {
        title: "P2",
        criteria: "sentence",
        template: "simple",
        tags: "M4_KN_READ",
      },
      {
        title: "P3",
        criteria: "sentence",
        template: "simple",
        tags: "M4_KN_READ",
      },
      {
        title: "P4",
        criteria: "sentence",
        template: "simple",
        tags: "M4_KN_READ",
      },
      {
        title: "S1",
        criteria: "sentence",
        template: "simple",
        tags: "M4_KN_READ",
      },
      {
        title: "P5",
        criteria: "sentence",
        template: "simple",
        tags: "M4_KN_READ",
      },
      {
        title: "P6",
        criteria: "sentence",
        template: "simple",
        tags: "M4_KN_READ",
      },
      {
        title: "P7",
        criteria: "sentence",
        template: "simple",
        tags: "M4_KN_READ",
      },
      {
        title: "P8",
        criteria: "sentence",
        template: "simple",
        tags: "M4_KN_READ",
      },
      {
        title: "S2",
        criteria: "sentence",
        template: "simple",
        tags: "M4_KN_READ",
      },
    ],
    5: [
      {
        title: "P1",
        criteria: "sentence",
        template: "simple",
        tags: "M5_KN_READ",
      },
      {
        title: "P2",
        criteria: "sentence",
        template: "simple",
        tags: "M5_KN_READ",
      },
      {
        title: "P3",
        criteria: "sentence",
        template: "simple",
        tags: "M5_KN_READ",
      },
      {
        title: "P4",
        criteria: "sentence",
        template: "simple",
        tags: "M5_KN_READ",
      },
      {
        title: "S1",
        criteria: "sentence",
        template: "simple",
        tags: "M5_KN_READ",
      },
      {
        title: "P5",
        criteria: "sentence",
        template: "simple",
        tags: "M5_KN_READ",
      },
      {
        title: "P6",
        criteria: "sentence",
        template: "simple",
        tags: "M5_KN_READ",
      },
      {
        title: "P7",
        criteria: "sentence",
        template: "simple",
        tags: "M5_KN_READ",
      },
      {
        title: "P8",
        criteria: "sentence",
        template: "simple",
        tags: "M5_KN_READ",
      },
      {
        title: "S2",
        criteria: "sentence",
        template: "simple",
        tags: "M5_KN_READ",
      },
    ],
    6: [
      {
        title: "P1",
        criteria: "sentence",
        template: "simple",
        tags: "M6_KN_READ",
      },
      {
        title: "P2",
        criteria: "sentence",
        template: "simple",
        tags: "M6_KN_READ",
      },
      {
        title: "P3",
        criteria: "sentence",
        template: "simple",
        tags: "M6_KN_READ",
      },
      {
        title: "P4",
        criteria: "sentence",
        template: "simple",
        tags: "M6_KN_READ",
      },
      {
        title: "S1",
        criteria: "sentence",
        template: "simple",
        tags: "M6_KN_READ",
      },
      {
        title: "P5",
        criteria: "sentence",
        template: "simple",
        tags: "M6_KN_READ",
      },
      {
        title: "P6",
        criteria: "sentence",
        template: "simple",
        tags: "M6_KN_READ",
      },
      {
        title: "P7",
        criteria: "sentence",
        template: "simple",
        tags: "M6_KN_READ",
      },
      {
        title: "P8",
        criteria: "sentence",
        template: "simple",
        tags: "M6_KN_READ",
      },
      {
        title: "S2",
        criteria: "sentence",
        template: "simple",
        tags: "M6_KN_READ",
      },
    ],
    7: [
      {
        title: "P1",
        criteria: "paragraph",
        template: "simple",
        tags: "M7_KN_READ",
      },
      {
        title: "P2",
        criteria: "paragraph",
        template: "simple",
        tags: "M7_KN_READ",
      },
      {
        title: "P3",
        criteria: "paragraph",
        template: "simple",
        tags: "M7_KN_READ",
      },
      {
        title: "P4",
        criteria: "paragraph",
        template: "simple",
        tags: "M7_KN_READ",
      },
      {
        title: "S1",
        criteria: "paragraph",
        template: "simple",
        tags: "M7_KN_READ",
      },
      {
        title: "P5",
        criteria: "paragraph",
        template: "simple",
        tags: "M7_KN_READ",
      },
      {
        title: "P6",
        criteria: "paragraph",
        template: "simple",
        tags: "M7_KN_READ",
      },
      {
        title: "P7",
        criteria: "paragraph",
        template: "simple",
        tags: "M7_KN_READ",
      },
      {
        title: "P8",
        criteria: "paragraph",
        template: "simple",
        tags: "M7_KN_READ",
      },
      {
        title: "S2",
        criteria: "paragraph",
        template: "simple",
        tags: "M7_KN_READ",
      },
    ],
    8: [
      {
        title: "P1",
        criteria: "paragraph",
        template: "simple",
        tags: "M8_KN_READ",
      },
      {
        title: "P2",
        criteria: "paragraph",
        template: "simple",
        tags: "M8_KN_READ",
      },
      {
        title: "P3",
        criteria: "paragraph",
        template: "simple",
        tags: "M8_KN_READ",
      },
      {
        title: "P4",
        criteria: "paragraph",
        template: "simple",
        tags: "M8_KN_READ",
      },
      {
        title: "S1",
        criteria: "paragraph",
        template: "simple",
        tags: "M8_KN_READ",
      },
      {
        title: "P5",
        criteria: "paragraph",
        template: "simple",
        tags: "M8_KN_READ",
      },
      {
        title: "P6",
        criteria: "paragraph",
        template: "simple",
        tags: "M8_KN_READ",
      },
      {
        title: "P7",
        criteria: "paragraph",
        template: "simple",
        tags: "M8_KN_READ",
      },
      {
        title: "P8",
        criteria: "paragraph",
        template: "simple",
        tags: "M8_KN_READ",
      },
      {
        title: "S2",
        criteria: "paragraph",
        template: "simple",
        tags: "M8_KN_READ",
      },
    ],
    9: [
      {
        title: "P1",
        criteria: "paragraph",
        template: "simple",
        tags: "M9_KN_READ",
      },
      {
        title: "P2",
        criteria: "paragraph",
        template: "simple",
        tags: "M9_KN_READ",
      },
      {
        title: "P3",
        criteria: "paragraph",
        template: "simple",
        tags: "M9_KN_READ",
      },
      {
        title: "P4",
        criteria: "paragraph",
        template: "simple",
        tags: "M9_KN_READ",
      },
      {
        title: "S1",
        criteria: "paragraph",
        template: "simple",
        tags: "M9_KN_READ",
      },
      {
        title: "P5",
        criteria: "paragraph",
        template: "simple",
        tags: "M9_KN_READ",
      },
      {
        title: "P6",
        criteria: "paragraph",
        template: "simple",
        tags: "M9_KN_READ",
      },
      {
        title: "P7",
        criteria: "paragraph",
        template: "simple",
        tags: "M9_KN_READ",
      },
      {
        title: "P8",
        criteria: "paragraph",
        template: "simple",
        tags: "M9_KN_READ",
      },
      {
        title: "S2",
        criteria: "paragraph",
        template: "simple",
        tags: "M9_KN_READ",
      },
    ],
  },
  te: {
    B: [
      {
        title: "P1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L1",
        storyMode: true,
        multilingual: false,
      },
      {
        title: "P2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L2",
        multilingual: false,
      },
      {
        title: "P3",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P1",
        multilingual: false,
      },
      {
        title: "P4",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P2",
        multilingual: false,
      },
      {
        title: "S1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_S1",
        multilingual: false,
      },
      {
        title: "P5",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L3",
        multilingual: false,
      },
      {
        title: "P6",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L4",
        multilingual: false,
      },
      {
        title: "P7",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P3",
        multilingual: false,
      },
      {
        title: "P8",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P4",
        multilingual: false,
      },
      {
        title: "S2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_S2",
        multilingual: false,
      },
    ],
    F1: [
      // Learn 1 - Letter Train
      {
        title: "L1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L1",
        multilingual: false,
        mechanism: { id: "letterTrain", name: "letterTrain" },
        customLetters: ["త", "బ", "ల", "క", "జ"],
        contentCount: 10,
      },
      // Practice 1 - Letter Hunt (1 level, 10 content)
      {
        title: "P1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L2",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 1,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Learn 2 - Letter Train
      {
        title: "L2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P1",
        multilingual: false,
        mechanism: { id: "letterTrain", name: "letterTrain" },
        customLetters: ["ర", "ఆ", "ట", "ఉ", "గ"],
        contentCount: 10,
      },
      // Practice 2 - Letter Hunt (1 level, 10 content)
      {
        title: "P2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P2",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 2,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Learn 3 - Letter Train
      {
        title: "L3",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L3",
        multilingual: false,
        mechanism: { id: "letterTrain", name: "letterTrain" },
        customLetters: ["శ", "అ", "న", "ప", "స"],
        contentCount: 10,
      },
      // Practice 3 - Letter Hunt (1 level, 10 content)
      {
        title: "P3",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L4",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 3,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Apply 1 - Letter Hunt (3 levels, 13 content per level, showcase mode)
      {
        title: "A1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P3",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 1,
        letterHuntEndLevel: 3,
        letterHuntContentCount: 13,
        isShowcase: true,
        applyStep: 1,
        contentCount: 30,
        failRedirect: "L1", // If fail at any level, go to Learn 1
        passRedirect: "L4", // If pass all levels, go to Learn 4
      },
      // Learn 4 - Letter Train
      {
        title: "L4",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P4",
        multilingual: false,
        mechanism: { id: "letterTrain", name: "letterTrain" },
        customLetters: ["వ", "ఊ", "డ", "ద", "ఈ"],
        contentCount: 10,
      },
      // Practice 4 - Letter Hunt (1 level, 10 content)
      {
        title: "P4",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P5",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 4,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Learn 5 - Letter Train
      {
        title: "L5",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L5",
        multilingual: false,
        mechanism: { id: "letterTrain", name: "letterTrain" },
        customLetters: ["మ", "చ", "ఒ", "ఓ", "ఔ"],
        contentCount: 10,
      },
      // Practice 5 - Letter Hunt (1 level, 10 content)
      {
        title: "P5",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L6",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 5,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Learn 6 - Letter Train
      {
        title: "L6",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P6",
        multilingual: false,
        mechanism: { id: "letterTrain", name: "letterTrain" },
        customLetters: ["య", "ఇ", "ఎ", "ఏ", "ఐ"],
        contentCount: 10,
      },
      // Practice 6 - Letter Hunt (1 level, 10 content)
      {
        title: "P6",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P7",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 6,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Apply 2 - Letter Hunt (3 levels, 13 content per level, showcase mode)
      {
        title: "A2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P8",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 4,
        letterHuntEndLevel: 6,
        letterHuntContentCount: 13,
        isShowcase: true,
        applyStep: 2,
        contentCount: 30,
        failRedirect: "L4", // If fail at any level, go to Learn 4
        passRedirect: "L7", // If pass all levels, go to Learn 7
      },
      // Learn 7 - Letter Train
      {
        title: "L7",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P9",
        multilingual: false,
        mechanism: { id: "letterTrain", name: "letterTrain" },
        customLetters: ["ణ", "ళ", "హ", "ఖ", "ఛ"],
        contentCount: 10,
      },
      // Practice 7 - Letter Hunt (1 level, 10 content)
      {
        title: "P7",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P10",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 7,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Learn 8 - Letter Train
      {
        title: "L8",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P11",
        multilingual: false,
        mechanism: { id: "letterTrain", name: "letterTrain" },
        customLetters: ["ఠ", "ఢ", "ఘ", "ఝ", "ఋ"],
        contentCount: 10,
      },
      // Practice 8 - Letter Hunt (1 level, 10 content)
      {
        title: "P8",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P12",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 8,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Learn 9 - Letter Train
      {
        title: "L9",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P13",
        multilingual: false,
        mechanism: { id: "letterTrain", name: "letterTrain" },
        customLetters: ["ష", "థ", "ధ", "ఫ", "భ"],
        contentCount: 10,
      },
      // Practice 9 - Letter Hunt (1 level, 10 content)
      {
        title: "P9",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P14",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 9,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Apply 3 - Letter Hunt (3 levels, 13 content per level, showcase mode)
      {
        title: "A3",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P15",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 7,
        letterHuntEndLevel: 9,
        letterHuntContentCount: 13,
        isShowcase: true,
        applyStep: 3,
        contentCount: 30,
        failRedirect: "L7", // If fail at any level, go to Learn 7
        passRedirect: "F2", // If pass all levels, go to F2
      },
    ],
    F2: [
      // Learn 1 - Syllable Clap/Letter Train (English) or Barakadi (Indic)
      {
        title: "L1",
        contentCount: 10,
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L1",
        multilingual: false,
        mechanism: { id: "barakhadi", name: "barakhadi" }, // For English, use LetterTrain; for Indic, will use Barakhadi
        customLetters: ["గది", "చేను", "చీర", "గెల", "సౌధం"], // Placeholder - adjust based on F2 requirements
      },
      // Practice 1 - Letter Hunt (1 level, 10 content)
      {
        title: "P1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L2",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 10,
        letterHuntContentCount: 10,
        contentCount: 10,
        // customLetters: ["In", "The", "On", "An", "Am"],
      },
      // Learn 2 - Syllable Clap/Letter Hunt (English) or Barakadi (Indic)
      {
        title: "L2",
        contentCount: 10,
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P1",
        multilingual: false,
        mechanism: { id: "barakhadi", name: "barakhadi" }, // For English, use LetterTrain; for Indic, will use Barakhadi
        customLetters: ["గృహం", "జాతర", "గీరు", "జైలు", "కోకిల"], // Placeholder - adjust based on F2 requirements
      },
      // Practice 2 - Letter Hunt (1 level, 10 content)
      {
        title: "P2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P2",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        // customLetters: ["At", "It", "He", "She", "His"],
        multilingual: false,
        letterHuntLevel: 11,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Learn 3 - Syllable Clap/Letter Hunt (English) or Barakadi (Indic)
      {
        title: "L3",
        contentCount: 10,
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L3",
        multilingual: false,
        mechanism: { id: "barakhadi", name: "barakhadi" }, // For English, use LetterTrain; for Indic, will use Barakhadi
        customLetters: ["నౌక", "నీకు", "పోరు", "మెడ", "టోపీ"], // Placeholder - adjust based on F2 requirements
      },
      // Practice 3 - Letter Hunt (1 level, 10 content)
      {
        title: "P3",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_L4",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        // customLetters: ["The", "Is", "Are", "Or", "Up", "On"],
        multilingual: false,
        letterHuntLevel: 12,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Apply 1 - Letter Hunt (3 levels, 13 content per level, showcase mode)
      {
        title: "A1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P3",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 10,
        letterHuntEndLevel: 12,
        letterHuntContentCount: 13,
        isShowcase: true,
        applyStep: 1,
        contentCount: 30,
        failRedirect: "L1", // If fail at any level, go to Learn 1
        passRedirect: "L4", // If pass all levels, go to Learn 4
      },
      // Learn 4 - Syllable Clap/Letter Hunt (English) or Barakadi (Indic)
      {
        title: "L4",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P4",
        multilingual: false,
        mechanism: { id: "barakhadi", name: "barakhadi" },
        customLetters: ["డైరీ", "రోకలి", "సూది", "జౌళి", "సీసా"], // Placeholder - adjust based on F2 requirements
        contentCount: 10,
      },
      // Practice 4 - Letter Hunt (1 level, 10 content)
      {
        title: "P4",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P5",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        // customLetters: ["All", "In", "Ter", "Ing", "Up", "Him"],
        multilingual: false,
        letterHuntLevel: 13,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Learn 5 - Syllable Clap/Letter Hunt (English) or Barakadi (Indic)
      {
        title: "L5",
        contentCount: 10,
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P6",
        multilingual: false,
        mechanism: { id: "barakhadi", name: "barakhadi" },
        customLetters: ["బంతి", "టౌను", "బాలిక", "నెమలి", "పశువు"], // Placeholder - adjust based on F2 requirements
      },
      // Practice 5 - Letter Hunt (1 level, 10 content)
      {
        title: "P5",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P7",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 14,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Learn 6 - Syllable Clap/Letter Hunt (English) or Barakadi (Indic)
      {
        title: "L6",
        contentCount: 10,
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P8",
        multilingual: false,
        mechanism: { id: "barakhadi", name: "barakhadi" }, // For English, use LetterTrain; for Indic, will use Barakhadi
        customLetters: ["బూడిద", "నుదురు", "మైదానం", "నొసలు", "పొదుపు"], // Placeholder - adjust based on F2 requirements
      },
      // Practice 6 - Letter Hunt (1 level, 10 content)
      {
        title: "P6",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P9",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 15,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Apply 2 - Letter Hunt (3 levels, 13 content per level, showcase mode)
      {
        title: "A2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P10",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 13,
        letterHuntEndLevel: 15,
        letterHuntContentCount: 13,
        isShowcase: true,
        applyStep: 2,
        contentCount: 30,
        failRedirect: "L4", // If fail at any level, go to Learn 4
        passRedirect: "L7", // If pass all levels, go to Learn 7
      },
      // Learn 7 - Syllable Clap/Letter Hunt (English) or Barakadi (Indic)
      {
        title: "L7",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P11",
        multilingual: false,
        mechanism: { id: "barakhadi", name: "barakhadi" },
        customLetters: ["మేఘం", "పెరుగు", "భూకంపం", "పావురం", "జూకాలు"], // Placeholder - adjust based on F2 requirements
        contentCount: 10,
      },
      // Practice 7 - Letter Hunt (1 level, 10 content)
      {
        title: "P7",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P12",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 16,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Learn 8 - Syllable Clap/Letter Hunt (English) or Barakadi (Indic)
      {
        title: "L8",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P13",
        multilingual: false,
        mechanism: { id: "barakhadi", name: "barakhadi" },
        contentCount: 10,
        customLetters: ["పసిడి", "గాజులు", "నృపతి", "పైసలు", "మొదలు"], // Placeholder - adjust based on F2 requirements
      },
      // Practice 8 - Letter Hunt (1 level, 10 content)
      {
        title: "P8",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P14",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 17,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Learn 9 - Syllable Clap/Letter Hunt (English) or Barakadi (Indic)
      {
        title: "L9",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P15",
        multilingual: false,
        mechanism: { id: "barakhadi", name: "barakhadi" },
        contentCount: 10,
        customLetters: ["మాటలు", "వివాహం", "మూకుడు", "హృదయం", "బేడీలు"], // Placeholder - adjust based on F2 requirements
      },
      // Practice 9 - Letter Hunt (1 level, 10 content)
      {
        title: "P9",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P16",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 18,
        letterHuntContentCount: 10,
        contentCount: 10,
      },
      // Apply 3 - Letter Hunt (3 levels, 13 content per level, showcase mode)
      {
        title: "A3",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_P17",
        mechanism: { id: "letterHunt", name: "letterHunt" },
        multilingual: false,
        letterHuntLevel: 16,
        letterHuntEndLevel: 18,
        letterHuntContentCount: 13,
        isShowcase: true,
        applyStep: 3,
        contentCount: 30,
        failRedirect: "L7", // If fail at any level, go to Learn 7
        passRedirect: "F3", // If pass all levels, go to F3
      },
    ],
    F3: [
      // Practice 1 - Letter Speed (Letter Launcher) - Alphabet sets
      {
        title: "P1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_P1",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: false,
        contentType: "letter", // Alphabet sets
        letterLauncherLevel: 19,
        letterLauncherContentCount: 10,
        contentCount: 10,
      },
      // Practice 2 - Letter Speed (Letter Launcher) - Alphabet sets
      {
        title: "P2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_P2",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: false,
        contentType: "letter",
        letterLauncherLevel: 20,
        letterLauncherContentCount: 10,
        contentCount: 10,
      },
      // Practice 3 - Letter Speed (Letter Launcher) - Alphabet sets
      {
        title: "P3",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_P3",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: false,
        contentType: "letter",
        letterLauncherLevel: 21,
        letterLauncherContentCount: 10,
        contentCount: 10,
      },
      // Practice 4 - Letter Speed (Letter Launcher) - Alphabet sets
      {
        title: "P4",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_P4",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: false,
        contentType: "letter",
        letterLauncherLevel: 20,
        letterLauncherContentCount: 10,
        contentCount: 10,
      },
      // Practice 5 - Letter Speed (Letter Launcher) - Alphabet sets
      {
        title: "P5",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_P5",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: false,
        contentType: "letter",
        letterLauncherLevel: 21,
        letterLauncherContentCount: 10,
        contentCount: 10,
      },
      // Apply 1 - Letter Speed (Letter Launcher) 3 levels + Memory Challenge 3 levels
      {
        title: "A1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_A1",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: false,
        contentType: "letter",
        letterLauncherLevel: 19,
        letterLauncherEndLevel: 21,
        letterLauncherContentCount: 20,
        isShowcase: true,
        applyStep: 1,
        contentCount: 35, // 20 letterLauncher + 15 memoryChallenge (3 levels × 5 sequences)
        failRedirect: "P1", // If fail at any level, go to Practice 1
        passRedirect: "P6", // If pass all levels, go to Practice 6
        // After Letter Launcher completes, show Memory Challenge
        memoryChallengeLevel: 19,
        memoryChallengeEndLevel: 21,
        memoryChallengeContentCount: 5, // 5 sequences per level
      },
      // Practice 6 - Syllable Speed (Letter Launcher) - Syllable sets
      {
        title: "P6",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_P6",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: false,
        contentType: "syllable", // Syllable sets
        letterLauncherLevel: 22,
        letterLauncherContentCount: 10,
        contentCount: 10,
      },
      // Practice 7 - Syllable Speed (Letter Launcher) - Syllable sets
      {
        title: "P7",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_P7",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: false,
        contentType: "syllable",
        letterLauncherLevel: 23,
        letterLauncherContentCount: 10,
        contentCount: 10,
      },
      // Practice 8 - Syllable Speed (Letter Launcher) - Syllable sets
      {
        title: "P8",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_P8",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: false,
        contentType: "syllable",
        letterLauncherLevel: 24,
        letterLauncherContentCount: 10,
        contentCount: 10,
      },
      // Practice 9 - Syllable Speed (Letter Launcher) - Syllable sets
      {
        title: "P9",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_P9",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: false,
        contentType: "syllable",
        letterLauncherLevel: 23,
        letterLauncherContentCount: 10,
        contentCount: 10,
      },
      // Practice 10 - Syllable Speed (Letter Launcher) - Syllable sets
      {
        title: "P10",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_P10",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: false,
        contentType: "syllable",
        letterLauncherLevel: 24,
        letterLauncherContentCount: 10,
        contentCount: 10,
      },
      // Apply 2 - Syllable Speed (Letter Launcher) 1 level + Memory Challenge 3 levels + Read Aloud
      {
        title: "A2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_GEN_M1_F3_A2",
        mechanism: { id: "letterLauncher", name: "letterLauncher" },
        multilingual: false,
        contentType: "syllable",
        letterLauncherLevel: 22,
        letterLauncherEndLevel: 24,
        letterLauncherContentCount: 20,
        isShowcase: true,
        applyStep: 2,
        contentCount: 45, // 20 letterLauncher + 15 memoryChallenge (3 levels × 5 sequences) + 10 readAloud
        failRedirect: "P6", // If fail at any level, go to Practice 6
        passRedirect: "complete", // If pass all levels, complete F3
        // After Letter Launcher completes, show Memory Challenge
        memoryChallengeLevel: 22,
        memoryChallengeEndLevel: 24,
        memoryChallengeContentCount: 5, // 5 sequences per level
        // After Memory Challenge completes, show Read Aloud
        readAloudContentCount: 10, // 10 simple root words
      },
    ],
    0: [
      { title: "P1", criteria: "word", template: "simple" },
      { title: "P2", criteria: "word", template: "simple" },
      { title: "P3", criteria: "word", template: "simple" },
      { title: "P4", criteria: "word", template: "simple" },
      { title: "S1", criteria: "word", template: "simple" },
      { title: "P5", criteria: "word", template: "simple" },
      { title: "P6", criteria: "word", template: "simple" },
      { title: "P7", criteria: "word", template: "simple" },
      { title: "P8", criteria: "word", template: "simple" },
      { title: "S2", criteria: "word", template: "simple" },
    ],
    1: [
      {
        title: "P1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M1_L1",
        contentCount: 10,
        // storyMode: true,
        mechanism: { id: "mechanic_7", name: "formAWord2" },
        multilingual: false,
      },
      {
        title: "P2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M1_L2",
        contentCount: 10,
        mechanism: { id: "mechanic_7", name: "formAWord2" },
        multilingual: false,
      },
      {
        title: "P3",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M1_P1",
        contentCount: 10,
        mechanism: { id: "soundHunt", name: "soundHunt" },
        multilingual: false,
      },
      {
        title: "P4",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M1_P2",
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "S1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M1_S1",
        contentCount: 10,
        mechanism: { id: "soundHuntS1Combined", name: "soundHuntS1Combined" },
        multilingual: false,
      },
      {
        title: "P5",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M1_L3",
        contentCount: 10,
        mechanism: { id: "mechanic_7", name: "formAWord2" },
        multilingual: false,
      },
      {
        title: "P6",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M1_L4",
        contentCount: 10,
        mechanism: { id: "mechanic_7", name: "formAWord2" },
        multilingual: false,
      },
      {
        title: "P7",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M1_P3",
        mechanism: { id: "soundHunt", name: "soundHunt" },
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "P8",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M1_P4",
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "S2",
        criteria: "word",
        template: "simple",
        mechanism: { id: "soundHuntS1Combined", name: "soundHuntS1Combined" },
        contentCount: 10,
        tags: "CEFR_M1_S2",
        multilingual: false,
      },
    ],
    2: [
      {
        title: "P1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M2_L1",
        mechanism: { id: "bingo_card", name: "bingoCard" },
        //storyMode: true,
        multilingual: false,
      },
      {
        title: "P2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M2_L2",
        mechanism: { id: "bingo_card", name: "bingoCard" },
        multilingual: false,
      },
      {
        title: "P3",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M2_P1",
        // mechanism: { id: "soundHunt", name: "soundHunt" },
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "P4",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M2_P2",
        mechanism: { id: "soundHunt", name: "soundHunt" },
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "S1",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M2_S1",
        mechanism: { id: "soundHuntS1Combined", name: "soundHuntS1Combined" },
        multilingual: false,
      },
      {
        title: "P5",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M2_L3",
        mechanism: { id: "bingo_card", name: "bingoCard" },
        multilingual: false,
      },
      {
        title: "P6",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M2_L4",
        mechanism: { id: "bingo_card", name: "bingoCard" },
        multilingual: false,
      },
      {
        title: "P7",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M2_P3",
        mechanism: { id: "soundHunt", name: "soundHunt" },
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "P8",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M2_P4",
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "S2",
        criteria: "word",
        template: "simple",
        tags: "CEFR_M2_S2",
        mechanism: { id: "soundHuntS1Combined", name: "soundHuntS1Combined" },
        multilingual: false,
      },
    ],
    3: [
      {
        title: "P1",
        criteria: "sentence",
        template: "simple",
        tags: "CEFR_M3_L1",
        //storyMode: true,
        mechanism: { id: "PhrasesInAction", name: "PhrasesInAction" },
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "P2",
        criteria: "sentence",
        template: "simple",
        tags: "CEFR_M3_L2",
        mechanism: { id: "PhrasesInAction", name: "PhrasesInAction" },
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "P3",
        criteria: "sentence",
        template: "simple",
        tags: "CEFR_M3_P1",
        // mechanism: { id: "PhrasesInAction", name: "PhrasesInAction" },
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "P4",
        criteria: "sentence",
        template: "simple",
        tags: "CEFR_M3_P2",
        //competency: "L1.1",
        // mechanism: { id: "PhrasesInAction", name: "PhrasesInAction" },
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "S1",
        criteria: "sentence",
        template: "simple",
        tags: "CEFR_M3_S1",
        mechanism: { id: "soundHuntS1Combined", name: "soundHuntS1Combined" },
      },
      {
        title: "P5",
        criteria: "sentence",
        template: "simple",
        tags: "CEFR_M3_L3",
        mechanism: { id: "PhrasesInAction", name: "PhrasesInAction" },
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "P6",
        criteria: "sentence",
        template: "simple",
        tags: "CEFR_M3_L4",
        mechanism: { id: "PhrasesInAction", name: "PhrasesInAction" },
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "P7",
        criteria: "sentence",
        template: "simple",
        tags: "CEFR_M3_P3",
        // mechanism: { id: "PhrasesInAction", name: "PhrasesInAction" },
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "P8",
        criteria: "sentence",
        template: "simple",
        tags: "CEFR_M3_P4",
        //competency: "L1.1",
        // mechanism: { id: "PhrasesInAction", name: "PhrasesInAction" },
        contentCount: 10,
        multilingual: false,
      },
      {
        title: "S2",
        criteria: "sentence",
        template: "simple",
        tags: "CEFR_M3_S2",
        mechanism: { id: "soundHuntS1Combined", name: "soundHuntS1Combined" },
      },
    ],
    4: [
      {
        title: "P1",
        criteria: "sentence",
        template: "simple",
        tags: "M4_TE_READ",
      },
      {
        title: "P2",
        criteria: "sentence",
        template: "simple",
        tags: "M4_TE_MECH",
        mechanism: { id: "mechanic_2", name: "readTheImage" },
      },
      {
        title: "P3",
        criteria: "sentence",
        template: "simple",
        tags: "M4_TE_READ",
      },
      {
        title: "P4",
        criteria: "sentence",
        template: "simple",
        tags: "M4_TE_READ",
      },
      {
        title: "S1",
        criteria: "sentence",
        template: "simple",
        tags: "M4_TE_READ",
      },
      {
        title: "P5",
        criteria: "sentence",
        template: "simple",
        tags: "M4_TE_READ",
      },
      {
        title: "P6",
        criteria: "sentence",
        template: "simple",
        tags: "M4_TE_MECH",
        mechanism: { id: "mechanic_2", name: "readTheImage" },
      },
      {
        title: "P7",
        criteria: "sentence",
        template: "simple",
        tags: "M4_TE_READ",
      },
      {
        title: "P8",
        criteria: "sentence",
        template: "simple",
        tags: "M4_TE_READ",
      },
      {
        title: "S2",
        criteria: "sentence",
        template: "simple",
        tags: "M4_TE_READ",
      },
    ],
    5: [
      {
        title: "P1",
        criteria: "sentence",
        template: "simple",
        tags: "M5_TE_READ",
      },
      {
        title: "P2",
        criteria: "sentence",
        template: "simple",
        tags: "M5_TE_MECH",
        mechanism: { id: "mechanic_2", name: "readTheImage" },
      },
      {
        title: "P3",
        criteria: "sentence",
        template: "simple",
        tags: "M5_TE_READ",
      },
      {
        title: "P4",
        criteria: "sentence",
        template: "simple",
        tags: "M5_TE_READ",
      },
      {
        title: "S1",
        criteria: "sentence",
        template: "simple",
        tags: "M5_TE_READ",
      },
      {
        title: "P5",
        criteria: "sentence",
        template: "simple",
        tags: "M5_TE_READ",
      },
      {
        title: "P6",
        criteria: "sentence",
        template: "simple",
        tags: "M5_TE_MECH",
        mechanism: { id: "mechanic_2", name: "readTheImage" },
      },
      {
        title: "P7",
        criteria: "sentence",
        template: "simple",
        tags: "M5_TE_READ",
      },
      {
        title: "P8",
        criteria: "sentence",
        template: "simple",
        tags: "M5_TE_READ",
      },
      {
        title: "S2",
        criteria: "sentence",
        template: "simple",
        tags: "M5_TE_READ",
      },
    ],
    6: [
      {
        title: "P1",
        criteria: "sentence",
        template: "simple",
        tags: "M6_TE_READ",
      },
      {
        title: "P2",
        criteria: "sentence",
        template: "simple",
        tags: "M6_TE_MECH",
        mechanism: { id: "mechanic_2", name: "readTheImage" },
      },
      {
        title: "P3",
        criteria: "sentence",
        template: "simple",
        tags: "M6_TE_READ",
      },
      {
        title: "P4",
        criteria: "sentence",
        template: "simple",
        tags: "M6_TE_READ",
      },
      {
        title: "S1",
        criteria: "sentence",
        template: "simple",
        tags: "M6_TE_READ",
      },
      {
        title: "P5",
        criteria: "sentence",
        template: "simple",
        tags: "M6_TE_READ",
      },
      {
        title: "P6",
        criteria: "sentence",
        template: "simple",
        tags: "M6_TE_MECH",
        mechanism: { id: "mechanic_2", name: "readTheImage" },
      },
      {
        title: "P7",
        criteria: "sentence",
        template: "simple",
        tags: "M6_TE_READ",
      },
      {
        title: "P8",
        criteria: "sentence",
        template: "simple",
        tags: "M6_TE_READ",
      },
      {
        title: "S2",
        criteria: "sentence",
        template: "simple",
        tags: "M6_TE_READ",
      },
    ],
    7: [
      {
        title: "P1",
        criteria: "paragraph",
        template: "simple",
        tags: "M7_TE_READ",
      },
      {
        title: "P2",
        criteria: "paragraph",
        template: "simple",
        tags: "M7_TE_MECH",
        mechanism: { id: "mechanic_2", name: "readTheImage" },
      },
      {
        title: "P3",
        criteria: "paragraph",
        template: "simple",
        tags: "M7_TE_READ",
      },
      {
        title: "P4",
        criteria: "paragraph",
        template: "simple",
        tags: "M7_TE_READ",
      },
      {
        title: "S1",
        criteria: "paragraph",
        template: "simple",
        tags: "M7_TE_READ",
      },
      {
        title: "P5",
        criteria: "paragraph",
        template: "simple",
        tags: "M7_TE_READ",
      },
      {
        title: "P6",
        criteria: "paragraph",
        template: "simple",
        tags: "M7_TE_MECH",
        mechanism: { id: "mechanic_2", name: "readTheImage" },
      },
      {
        title: "P7",
        criteria: "paragraph",
        template: "simple",
        tags: "M7_TE_READ",
      },
      {
        title: "P8",
        criteria: "paragraph",
        template: "simple",
        tags: "M7_TE_READ",
      },
      {
        title: "S2",
        criteria: "paragraph",
        template: "simple",
        tags: "M7_TE_READ",
      },
    ],
    8: [
      {
        title: "P1",
        criteria: "paragraph",
        template: "simple",
        tags: "M8_TE_READ",
      },
      {
        title: "P2",
        criteria: "paragraph",
        template: "simple",
        tags: "M8_TE_MECH",
        mechanism: { id: "mechanic_2", name: "readTheImage" },
      },
      {
        title: "P3",
        criteria: "paragraph",
        template: "simple",
        tags: "M8_TE_READ",
      },
      {
        title: "P4",
        criteria: "paragraph",
        template: "simple",
        tags: "M8_TE_READ",
      },
      {
        title: "S1",
        criteria: "paragraph",
        template: "simple",
        tags: "M8_TE_READ",
      },
      {
        title: "P5",
        criteria: "paragraph",
        template: "simple",
        tags: "M8_TE_READ",
      },
      {
        title: "P6",
        criteria: "paragraph",
        template: "simple",
        tags: "M8_TE_MECH",
        mechanism: { id: "mechanic_2", name: "readTheImage" },
      },
      {
        title: "P7",
        criteria: "paragraph",
        template: "simple",
        tags: "M8_TE_READ",
      },
      {
        title: "P8",
        criteria: "paragraph",
        template: "simple",
        tags: "M8_TE_READ",
      },
      {
        title: "S2",
        criteria: "paragraph",
        template: "simple",
        tags: "M8_TE_READ",
      },
    ],
    9: [
      {
        title: "P1",
        criteria: "paragraph",
        template: "simple",
        tags: "M9_TE_READ",
      },
      {
        title: "P2",
        criteria: "paragraph",
        template: "simple",
        tags: "M9_TE_MECH",
        mechanism: { id: "mechanic_2", name: "readTheImage" },
      },
      {
        title: "P3",
        criteria: "paragraph",
        template: "simple",
        tags: "M9_TE_READ",
      },
      {
        title: "P4",
        criteria: "paragraph",
        template: "simple",
        tags: "M9_TE_READ",
      },
      {
        title: "S1",
        criteria: "paragraph",
        template: "simple",
        tags: "M9_TE_READ",
      },
      {
        title: "P5",
        criteria: "paragraph",
        template: "simple",
        tags: "M9_TE_READ",
      },
      {
        title: "P6",
        criteria: "paragraph",
        template: "simple",
        tags: "M9_TE_MECH",
        mechanism: { id: "mechanic_2", name: "readTheImage" },
      },
      {
        title: "P7",
        criteria: "paragraph",
        template: "simple",
        tags: "M9_TE_READ",
      },
      {
        title: "P8",
        criteria: "paragraph",
        template: "simple",
        tags: "M9_TE_READ",
      },
      {
        title: "S2",
        criteria: "paragraph",
        template: "simple",
        tags: "M9_TE_READ",
      },
    ],
  },
  gu: {
    0: [
      { title: "P1", criteria: "word", template: "simple" },
      { title: "P2", criteria: "word", template: "simple" },
      { title: "P3", criteria: "word", template: "simple" },
      { title: "P4", criteria: "word", template: "simple" },
      { title: "S1", criteria: "word", template: "simple" },
      { title: "P5", criteria: "word", template: "simple" },
      { title: "P6", criteria: "word", template: "simple" },
      { title: "P7", criteria: "word", template: "simple" },
      { title: "P8", criteria: "word", template: "simple" },
      { title: "S2", criteria: "word", template: "simple" },
    ],
    1: [
      { title: "P1", criteria: "word", template: "simple" },
      { title: "P2", criteria: "word", template: "simple" },
      { title: "P3", criteria: "word", template: "simple" },
      { title: "P4", criteria: "word", template: "simple" },
      { title: "S1", criteria: "word", template: "simple" },
      { title: "P5", criteria: "word", template: "simple" },
      { title: "P6", criteria: "word", template: "simple" },
      { title: "P7", criteria: "word", template: "simple" },
      { title: "P8", criteria: "word", template: "simple" },
      { title: "S2", criteria: "word", template: "simple" },
    ],
    2: [
      { title: "P1", criteria: "word", template: "simple" },
      { title: "P2", criteria: "word", template: "simple" },
      { title: "P3", criteria: "word", template: "simple" },
      { title: "P4", criteria: "word", template: "simple" },
      { title: "S1", criteria: "word", template: "simple" },
      { title: "P5", criteria: "word", template: "simple" },
      { title: "P6", criteria: "word", template: "simple" },
      { title: "P7", criteria: "word", template: "simple" },
      { title: "P8", criteria: "word", template: "simple" },
      { title: "S2", criteria: "word", template: "simple" },
    ],
    3: [
      { title: "P1", criteria: "word", template: "simple" },
      { title: "P2", criteria: "word", template: "simple" },
      { title: "P3", criteria: "sentence", template: "simple" },
      { title: "P4", criteria: "sentence", template: "simple" },
      { title: "S1", criteria: "sentence", template: "simple" },
      { title: "P5", criteria: "sentence", template: "simple" },
      { title: "P6", criteria: "sentence", template: "simple" },
      { title: "P7", criteria: "sentence", template: "simple" },
      { title: "P8", criteria: "sentence", template: "simple" },
      { title: "S2", criteria: "sentence", template: "simple" },
    ],
    4: [
      { title: "P1", criteria: "word", template: "simple" },
      { title: "P2", criteria: "word", template: "simple" },
      { title: "P3", criteria: "sentence", template: "simple" },
      { title: "P4", criteria: "sentence", template: "simple" },
      { title: "S1", criteria: "sentence", template: "simple" },
      { title: "P5", criteria: "sentence", template: "simple" },
      { title: "P6", criteria: "sentence", template: "simple" },
      { title: "P7", criteria: "sentence", template: "simple" },
      { title: "P8", criteria: "sentence", template: "simple" },
      { title: "S2", criteria: "sentence", template: "simple" },
    ],
    5: [
      { title: "P1", criteria: "sentence", template: "simple" },
      { title: "P2", criteria: "sentence", template: "simple" },
      { title: "P3", criteria: "sentence", template: "simple" },
      { title: "P4", criteria: "sentence", template: "simple" },
      { title: "S1", criteria: "sentence", template: "simple" },
      { title: "P5", criteria: "sentence", template: "simple" },
      { title: "P6", criteria: "sentence", template: "simple" },
      { title: "P7", criteria: "sentence", template: "simple" },
      { title: "P8", criteria: "sentence", template: "simple" },
      { title: "S2", criteria: "sentence", template: "simple" },
    ],
    6: [
      { title: "P1", criteria: "sentence", template: "simple" },
      { title: "P2", criteria: "sentence", template: "simple" },
      { title: "P3", criteria: "paragraph", template: "simple" },
      { title: "P4", criteria: "paragraph", template: "simple" },
      { title: "S1", criteria: "paragraph", template: "simple" },
      { title: "P5", criteria: "sentence", template: "simple" },
      { title: "P6", criteria: "paragraph", template: "simple" },
      { title: "P7", criteria: "paragraph", template: "simple" },
      { title: "P8", criteria: "paragraph", template: "simple" },
      { title: "S2", criteria: "paragraph", template: "simple" },
    ],
    7: [
      { title: "P1", criteria: "sentence", template: "simple" },
      { title: "P2", criteria: "sentence", template: "simple" },
      { title: "P3", criteria: "paragraph", template: "simple" },
      { title: "P4", criteria: "paragraph", template: "simple" },
      { title: "S1", criteria: "paragraph", template: "simple" },
      { title: "P5", criteria: "paragraph", template: "simple" },
      { title: "P6", criteria: "paragraph", template: "simple" },
      { title: "P7", criteria: "paragraph", template: "simple" },
      { title: "P8", criteria: "paragraph", template: "simple" },
      { title: "S2", criteria: "paragraph", template: "simple" },
    ],
    8: [
      { title: "P1", criteria: "sentence", template: "simple" },
      { title: "P2", criteria: "sentence", template: "simple" },
      { title: "P3", criteria: "paragraph", template: "simple" },
      { title: "P4", criteria: "paragraph", template: "simple" },
      { title: "S1", criteria: "paragraph", template: "simple" },
      { title: "P5", criteria: "paragraph", template: "simple" },
      { title: "P6", criteria: "paragraph", template: "simple" },
      { title: "P7", criteria: "paragraph", template: "simple" },
      { title: "P8", criteria: "paragraph", template: "simple" },
      { title: "S2", criteria: "paragraph", template: "simple" },
    ],
    9: [
      { title: "P1", criteria: "sentence", template: "simple" },
      { title: "P2", criteria: "sentence", template: "simple" },
      { title: "P3", criteria: "paragraph", template: "simple" },
      { title: "P4", criteria: "paragraph", template: "simple" },
      { title: "S1", criteria: "paragraph", template: "simple" },
      { title: "P5", criteria: "paragraph", template: "simple" },
      { title: "P6", criteria: "paragraph", template: "simple" },
      { title: "P7", criteria: "paragraph", template: "simple" },
      { title: "P8", criteria: "paragraph", template: "simple" },
      { title: "S2", criteria: "paragraph", template: "simple" },
    ],
  },
  or: {
    0: [
      { title: "P1", criteria: "word", template: "simple" },
      { title: "P2", criteria: "word", template: "simple" },
      { title: "P3", criteria: "word", template: "simple" },
      { title: "P4", criteria: "word", template: "simple" },
      { title: "S1", criteria: "word", template: "simple" },
      { title: "P5", criteria: "word", template: "simple" },
      { title: "P6", criteria: "word", template: "simple" },
      { title: "P7", criteria: "word", template: "simple" },
      { title: "P8", criteria: "word", template: "simple" },
      { title: "S2", criteria: "word", template: "simple" },
    ],
    1: [
      { title: "P1", criteria: "word", template: "simple" },
      { title: "P2", criteria: "word", template: "simple" },
      { title: "P3", criteria: "word", template: "simple" },
      { title: "P4", criteria: "word", template: "simple" },
      { title: "S1", criteria: "word", template: "simple" },
      { title: "P5", criteria: "word", template: "simple" },
      { title: "P6", criteria: "word", template: "simple" },
      { title: "P7", criteria: "word", template: "simple" },
      { title: "P8", criteria: "word", template: "simple" },
      { title: "S2", criteria: "word", template: "simple" },
    ],
    2: [
      { title: "P1", criteria: "word", template: "simple" },
      { title: "P2", criteria: "word", template: "simple" },
      { title: "P3", criteria: "word", template: "simple" },
      { title: "P4", criteria: "word", template: "simple" },
      { title: "S1", criteria: "word", template: "simple" },
      { title: "P5", criteria: "word", template: "simple" },
      { title: "P6", criteria: "word", template: "simple" },
      { title: "P7", criteria: "word", template: "simple" },
      { title: "P8", criteria: "word", template: "simple" },
      { title: "S2", criteria: "word", template: "simple" },
    ],
    3: [
      { title: "P1", criteria: "word", template: "simple" },
      { title: "P2", criteria: "word", template: "simple" },
      { title: "P3", criteria: "sentence", template: "simple" },
      { title: "P4", criteria: "sentence", template: "simple" },
      { title: "S1", criteria: "sentence", template: "simple" },
      { title: "P5", criteria: "sentence", template: "simple" },
      { title: "P6", criteria: "sentence", template: "simple" },
      { title: "P7", criteria: "sentence", template: "simple" },
      { title: "P8", criteria: "sentence", template: "simple" },
      { title: "S2", criteria: "sentence", template: "simple" },
    ],
    4: [
      { title: "P1", criteria: "word", template: "simple" },
      { title: "P2", criteria: "word", template: "simple" },
      { title: "P3", criteria: "sentence", template: "simple" },
      { title: "P4", criteria: "sentence", template: "simple" },
      { title: "S1", criteria: "sentence", template: "simple" },
      { title: "P5", criteria: "sentence", template: "simple" },
      { title: "P6", criteria: "sentence", template: "simple" },
      { title: "P7", criteria: "sentence", template: "simple" },
      { title: "P8", criteria: "sentence", template: "simple" },
      { title: "S2", criteria: "sentence", template: "simple" },
    ],
    5: [
      { title: "P1", criteria: "sentence", template: "simple" },
      { title: "P2", criteria: "sentence", template: "simple" },
      { title: "P3", criteria: "sentence", template: "simple" },
      { title: "P4", criteria: "sentence", template: "simple" },
      { title: "S1", criteria: "sentence", template: "simple" },
      { title: "P5", criteria: "sentence", template: "simple" },
      { title: "P6", criteria: "sentence", template: "simple" },
      { title: "P7", criteria: "sentence", template: "simple" },
      { title: "P8", criteria: "sentence", template: "simple" },
      { title: "S2", criteria: "sentence", template: "simple" },
    ],
    6: [
      { title: "P1", criteria: "sentence", template: "simple" },
      { title: "P2", criteria: "sentence", template: "simple" },
      { title: "P3", criteria: "paragraph", template: "simple" },
      { title: "P4", criteria: "paragraph", template: "simple" },
      { title: "S1", criteria: "paragraph", template: "simple" },
      { title: "P5", criteria: "sentence", template: "simple" },
      { title: "P6", criteria: "paragraph", template: "simple" },
      { title: "P7", criteria: "paragraph", template: "simple" },
      { title: "P8", criteria: "paragraph", template: "simple" },
      { title: "S2", criteria: "paragraph", template: "simple" },
    ],
    7: [
      { title: "P1", criteria: "sentence", template: "simple" },
      { title: "P2", criteria: "sentence", template: "simple" },
      { title: "P3", criteria: "paragraph", template: "simple" },
      { title: "P4", criteria: "paragraph", template: "simple" },
      { title: "S1", criteria: "paragraph", template: "simple" },
      { title: "P5", criteria: "paragraph", template: "simple" },
      { title: "P6", criteria: "paragraph", template: "simple" },
      { title: "P7", criteria: "paragraph", template: "simple" },
      { title: "P8", criteria: "paragraph", template: "simple" },
      { title: "S2", criteria: "paragraph", template: "simple" },
    ],
    8: [
      { title: "P1", criteria: "sentence", template: "simple" },
      { title: "P2", criteria: "sentence", template: "simple" },
      { title: "P3", criteria: "paragraph", template: "simple" },
      { title: "P4", criteria: "paragraph", template: "simple" },
      { title: "S1", criteria: "paragraph", template: "simple" },
      { title: "P5", criteria: "paragraph", template: "simple" },
      { title: "P6", criteria: "paragraph", template: "simple" },
      { title: "P7", criteria: "paragraph", template: "simple" },
      { title: "P8", criteria: "paragraph", template: "simple" },
      { title: "S2", criteria: "paragraph", template: "simple" },
    ],
    9: [
      { title: "P1", criteria: "sentence", template: "simple" },
      { title: "P2", criteria: "sentence", template: "simple" },
      { title: "P3", criteria: "paragraph", template: "simple" },
      { title: "P4", criteria: "paragraph", template: "simple" },
      { title: "S1", criteria: "paragraph", template: "simple" },
      { title: "P5", criteria: "paragraph", template: "simple" },
      { title: "P6", criteria: "paragraph", template: "simple" },
      { title: "P7", criteria: "paragraph", template: "simple" },
      { title: "P8", criteria: "paragraph", template: "simple" },
      { title: "S2", criteria: "paragraph", template: "simple" },
    ],
  },
};
